<template>
  <div class="sku-details">
    <div class="breadcrumb" style="background: #fff">编辑SKU组</div>
    <div class="third-title"><span>SKU组基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" ref="editForm" :rules="rules" :hide-required-asterisk="true" label-width="130px">
        <el-form-item label="SKU组名称:" prop="skuGroupName">
          <el-input v-model="basicInfo.skuGroupName" placeholder=""></el-input>
        </el-form-item>
        <!-- <el-form-item label="SKU组属性:" v-if="$route.query.spuProperty!=='NORMAL'">{{ basicInfo.dictSet }}</el-form-item> -->
        <div v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-form-item :label="item[0] + ':'" v-for="(item) in basicInfo.dicts" :key="item[1]">
            <span>{{ item[1] }}</span>
          </el-form-item>
        </div>
        <div v-if="$route.query.spuProperty === 'NORMAL'">
          <el-form-item :label="item.key + ':'" v-for="(item, index) in dictList" :key="item.id">
            <el-select v-model="dictList[index].value" value-key="id" placeholder="请选择">
              <el-option v-for="ele in item.vals" :key="ele.id" :label="ele.propVal" :value="ele"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="SKU组图片:" prop="skuGroupImage">
          <input @change="fileChange($event)" type="file" id="upload_file" style="display: none">
          <el-button type="primary" @click="updateImg" round>上传图片</el-button>
          <div id="show_img">
            <img :src="basicInfo.skuGroupImage" alt="">
          </div>
        </el-form-item>
        <el-form-item class="noleft-third-title" v-if="$route.query.spuProperty !== 'NORMAL'">
          <div class="third-title"><span>SKU组详细信息</span></div>
        </el-form-item>
        <el-form-item label="SKU:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-button v-if="$route.query.onSale !== 'true' && $hasPermission('pms:admin:sku:add')" v-show="!basicInfo.isSingleSkuGroup || basicInfo.skuList.length === 0" @click="addSku()"
            type="primary" round> 添加Sku</el-button>
          <!-- <el-button v-if="$route.query.onSale !== 'true' && !defaultSizeGroup" @click="getSizeGroupList(), type = 'all', sizeDialog = true" type="primary" round> 统一关联尺寸组</el-button> -->
          <!-- <el-button v-permission="'pts:admin:group:skuRelateGroup'"
            @click="propertyList=allPropertyList,addCorrelation=true,addCorrelationType='all',sizeGroupQueryInfo.pageNum=1,searchGroupVo.skuId='',getTemplateThemeList(),templateDialog= true"
            type="primary" round>统一关联模板组</el-button> -->
          <div style="max-width: 100%;margin-top:10px">
            <el-table :data="basicInfo.skuList" border>
              <el-table-column label="SKUID" prop="id"></el-table-column>
              <el-table-column label="SKU名称" prop="skuName" min-width="200px"></el-table-column>
              <el-table-column label="SKU前端显示名称" prop="skuFrontName"></el-table-column>
              <el-table-column label="基础P数" prop="basePage"></el-table-column>
              <el-table-column label="最大P数" prop="maxPage"></el-table-column>
              <el-table-column label="一次增加P数" prop="baseStep"></el-table-column>
              <el-table-column label="基础P平台价格" prop="basePagePrice"></el-table-column>
              <el-table-column label="增加一次平台价格" prop="baseStepPrice"></el-table-column>
              <el-table-column label="基础P在线支付价格" min-width="130px" prop="onlineSalePrice"></el-table-column>
              <el-table-column label="增加一次在线支付平台价格" prop="onlineBaseStepPrice"></el-table-column>
              <!-- 新加的 -->
              <el-table-column label="基础P初创平台价格" min-width="130px" prop="startupsBasePagePrice" v-if="startupsSpu == 'true'"></el-table-column>
              <el-table-column label="增加一次初创平台价价格" prop="startupsBaseStepPrice" v-if="startupsSpu == 'true'"></el-table-column>
              <el-table-column label="基础P推荐终端价格" prop="terminalSalePrice"></el-table-column>
              <el-table-column label="增加一次推荐终端价格" prop="terminalStepSalePrice"></el-table-column>
              <!-- <el-table-column label="最低终端价格" min-width="130px" prop="salePrice"></el-table-column> -->
              <el-table-column label="尺寸">
                <template slot-scope="scope">
                  <span class="color-blue" @click="checkSizeGroup(scope.row)">查看尺寸组</span>
                </template>
              </el-table-column>
              <el-table-column label="模板" v-permission="'pts:admin:group:list'">
                <template slot-scope="scope">
                  <span class="color-blue" @click="tempAdmin(scope)">管理模板</span>
                </template>
              </el-table-column>
              <!-- v-if="isDiy"  -->
              <el-table-column label="收选片模板" v-permission="'pts:admin:group:list'">
                <template slot-scope="scope">
                  <span :class="'color-blue'"
                    @click="$refs.adminPickCollTemplate.show(scope.row.id, scope.row.composeSizeGroupId, defaultSizeGroup.groupName, scope.row.maxPage, basicInfo.isPdf)">管理收选片模板</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="color-blue " v-if="$hasPermission('pms:admin:sku:detail')" @click="isEditSku = 'check', editSku(scope.row, 0)">查看<br></span>
                  <span class="color-blue " v-if="$hasPermission('pms:admin:sku:update')" @click="isEditSku = true, editSku(scope.row, 1)">编辑<br></span>
                  <span class="color-blue" @click="deleteSkuMsg = scope, deleteSkuDialog = true" v-if="$hasPermission('pms:admin:sku:delete') && $route.query.onSale !== 'true'">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="isShow" class="price-details">
          <div style="width: 302px;" v-for="(item, index) in priceTableList" :key="index">
            <el-table :data="item" border style="width: 302px">
              <el-table-column prop="page" label="P数" width="150"></el-table-column>
              <el-table-column prop="price" label="平台价格" width="150"></el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <span style="display:inline-block;width:200px;" v-show="!editPriceDialog">{{ basicInfo.samplePrice }}</span>
          <el-input v-show="editPriceDialog" v-model="basicInfo.samplePrice" placeholder=""></el-input>
          <el-button style="margin-left:0px" type="primary" @click="changeSamplePrice" round>{{ editPriceDialog ? '确定' : '编辑' }}</el-button>
        </el-form-item>
        <el-form-item label="在线支付样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <span style="display:inline-block;width:200px;" v-show="!onlineSamplePriceDialog">{{ basicInfo.onlineSamplePrice }}</span>
          <el-input v-show="onlineSamplePriceDialog" v-model="basicInfo.onlineSamplePrice" placeholder=""></el-input>
          <el-button style="margin-left:0px" type="primary" @click="changeOnlineSamplePrice" round>{{ onlineSamplePriceDialog ? '确定' : '编辑' }}</el-button>
        </el-form-item>
        <el-form-item label="初创平台样品价格:" v-if="$route.query.spuProperty !== 'NORMAL' && startupsSpu == 'true'">
          <span style="display:inline-block;width:200px;" v-show="!startupsSamplePriceDialog">{{ basicInfo.startupsSamplePrice }}</span>
          <el-input v-show="startupsSamplePriceDialog" v-model="basicInfo.startupsSamplePrice" placeholder=""></el-input>
          <el-button style="margin-left:0px" type="primary" @click="changeStartupsSamplePrice" round>{{ startupsSamplePriceDialog ? '确定' : '编辑' }}</el-button>
        </el-form-item>
        <el-form-item label="样品积分价格:" v-if="$route.query.showPoint == 'true' && $route.query.spuProperty !== 'NORMAL'">
          <span style="display:inline-block;width:200px;" v-show="!editePointsDialog">{{ basicInfo.samplePoints }}</span>
          <el-input v-show="editePointsDialog" v-model="basicInfo.samplePoints" placeholder=""></el-input>
          <el-button style="margin-left:0px" type="primary" @click="changeSamplePointPrice" round>{{ editePointsDialog ? '确定' : '编辑' }}</el-button>
        </el-form-item>
        <el-form-item label="样品主题:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-select clearable value-key="id" v-model="selectSample" placeholder="请选择" @change="onSelectSample">
            <el-option v-for="item in sampleList" :key="item.id" :label="item.themeName" :value="item">
            </el-option>
          </el-select>
          <el-button style="margin-left:20px;margin-bottom:10px" @click="addTheme" type="primary" round>添加</el-button>
          <div style="width: 602px">
            <el-table :data="basicInfo.sampleThemeList" border>
              <!-- <el-table-column label="样品编码" min-width="200px" prop="sampleBarCode"></el-table-column> -->
              <el-table-column label="主题" prop="themeName"></el-table-column>
              <el-table-column label="操作" prop="name">
                <template slot-scope="scope">
                  <span @click="deleteTheme(scope.row.id, scope.$index)" class="color-blue">删除</span>
                  <span @click="upLoadTheme(scope.row.id, scope.$index)" class="color-blue" style="margin-left: 10px;">上传</span>
                  <span @click="(scope.row.isUploaded || scope.row.skuGroupSampleImageList.length > 0) ? previewImg(scope.row.id, scope.$index) : ''"
                    :class="(scope.row.isUploaded || scope.row.skuGroupSampleImageList.length > 0) ? 'color-blue' : ''" style="margin-left: 10px;">预览</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL'" label="平台价格:">
          <el-input v-model="basicInfo.skuList[0].basePagePrice" placeholder=""></el-input>
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL' && $route.query.showPoint == 'true'" label="积分价格:">
          <el-input v-model="basicInfo.skuList[0].basePagePoints" placeholder=""></el-input>
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL'" label="在线支付价格:">
          <el-input v-model="basicInfo.skuList[0].onlineSalePrice" placeholder=""></el-input>
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL' && startupsSpu == 'true'" label="初创平台价格:">
          <el-input v-model="basicInfo.skuList[0].startupsBasePagePrice" placeholder=""></el-input>
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL'" label="推荐终端价格:">
          <el-input v-model="basicInfo.skuList[0].salePrice" placeholder=""></el-input>
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL'" label="通货编码:">
          <el-input v-model="basicInfo.skuList[0].sampleBarCode" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="特殊价格:" v-permission="'pms:admin:special:store:list'">
          <div style="width: 500px">
            <el-table :data="specialStoreList" border>
              <el-table-column label="平台号" prop="storeCode"></el-table-column>
              <el-table-column label="平台名称" prop="storeName"></el-table-column>
              <el-table-column label="业务" prop="salesman"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span @click="$router.push({ path: '/pricedetail', query: { id: scope.row.id } })" class="color-blue">查看</span><br>
                  <span @click="deleteSP(scope.row)" class="color-blue">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="库存:">
          <!-- <el-switch v-model="basicInfo.isTimeLimit" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)"> </el-switch> -->
          <!-- <div style="margin-top:10px;"> -->
          <el-input v-model="basicInfo.stockCount" placeholder=""></el-input>
          <!-- </div> -->
        </el-form-item>
        <el-form-item label="有效期:">
          <el-switch v-model="basicInfo.isTimeLimit" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)"> </el-switch>
          <div style="margin-top:10px;" v-show="basicInfo.isTimeLimit">
            <el-date-picker v-model="limitTime" type="daterange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button type="primary" @click="save" round>保存</el-button>
    </div>
    <!-- 查看尺寸组 -->
    <el-dialog :close-on-click-modal="false" width="900px" title="尺寸组" :visible.sync="haddleSizeGroupDialog">
      <el-table :data="checkSizeGroupTableData" border>
        <el-table-column type="expand">
          <template v-slot='scope'>
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型">
                  <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
                </el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight
                  }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                </el-table-column>
                <el-table-column label="码" prop="barCodeId">
                  <template slot-scope="scope">
                    <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="composeSizeGroupCategory.categoryName" min-width="100px"></el-table-column>
        <el-table-column label="页面名称" prop="pageName" min-width="100px">
          <template slot-scope="scope"> {{ scope.row.pageName.substring(0, scope.row.pageName.length - 1) }} </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 管理模板组 -->
    <el-dialog :close-on-click-modal="false" width="75%" title="模板" :visible.sync="templateDialog" @closed="templateDialogClosed">
      <el-form :inline="true" ref="templateSearchVo" :model="searchGroupVo" class="demo-form-inline">
        <el-form-item label="模板名称:">
          <el-input v-model="searchGroupVo.groupName" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <el-form-item label="模板主题:">
          <el-select v-model="searchGroupVo.templateThemeId" placeholder="请选择">
            <el-option v-for="item in sampleList" :key="item.id" :label="item.themeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板性质:">
          <el-select v-model="searchGroupVo.propertyId" clearable placeholder="请选择">
            <el-option v-for="item in propertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否关联尺寸组:">
          <el-select v-model="searchGroupVo.isAssociatedeSizeGroup" placeholder="请选择">
            <el-option label="不关联" value="0"></el-option>
            <el-option label="关联" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="创建日期:">
          <el-date-picker v-model="value" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item style="float:right;margin-right:20px">
          <el-button round @click="tempQueryInfo.pageNum = 1, getTemplateThemeList()">查询</el-button>
          <el-button round v-show="!addCorrelation"
            @click="searchGroupVo.propertyId = propertyList[0].id, sizeGroupQueryInfo.pageNum = 1, searchGroupVo.skuId = '', addCorrelation = true, getTemplateThemeList()" type="primary">添加关联
          </el-button>
        </el-form-item>
      </el-form>
      <el-table :data="templateGroupList" border style="width: 100%">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="groupName" label="模板名称"></el-table-column>
        <el-table-column prop="propertyName" label="模板性质"></el-table-column>
        <el-table-column prop="templateGroupList" label="模板页数量">
          <template slot-scope="scope">
            <p v-for="item in scope.row.templateGroupList" :key="scope.row.id + item.typeName">
              <span @click="getTemplateGroupMsg(scope.row.id), checkTemplateDialog = true" class="color-blue">{{ item.typeName + '模板：' + item.templateGroupNum }}</span>
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="isAssociatedeSizeGroup" label="是否关联尺寸组">
          <template slot-scope="scope">
            {{scope.row.isAssociatedeSizeGroup===1?'是':'否'}}
          </template>
        </el-table-column> -->
        <el-table-column prop="themeName" label="主题"></el-table-column>
        <el-table-column prop="createdTime" label="创建日期"></el-table-column>
        <el-table-column prop="skuMainImage" label="模板主图">
          <template slot-scope="scope">
            <div style="width:100%;position:relative;" v-if="scope.row.skuMainImage">
              <img style="width:100%" :src="scope.row.skuMainImage" alt="">
              <i class="el-icon-circle-close" style="color:#F56C6C;position:absolute;top:2px;right: 2px;z-index: 999;font-size: 18px;" @click="scope.row.skuMainImage = ''"></i>
            </div>
            <div class="upload-img" v-if="!scope.row.skuMainImage">
              <input type="file" name="" id="input_img" @change="fileSize($event, scope.row)" />
              <span class="color-blue">上传主图</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="templateImageList" label="细节模板主图" width="140">
          <template slot-scope="scope">
            <div class="detail-scroll" style="display:flex;flex-wrap:wrap;gap:5px;max-height:130px;overflow-y:auto;scrollbar-width:none;"
              v-if="scope.row.templateImageList && scope.row.templateImageList.length > 0">
              <div v-for="(img, index) in scope.row.templateImageList" :key="index" style="position:relative;width:50px;height:50px;margin:2px">
                <img style="width:100%;height:100%;object-fit:cover;" :src="img" alt="">
                <i class="el-icon-circle-close" style="color:#F56C6C;position:absolute;top:-5px;right:-5px;z-index: 999;font-size: 16px;cursor:pointer;"
                  @click="removeDetailImage(scope.row, index)"></i>
              </div>
            </div>
            <div class="upload-img" v-else>
              <input type="file" id="input_img" multiple @change="fileSizeDetail($event, scope.row)" />
              <span class="color-blue">上传细节图</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" v-if="!addCorrelation" label="是否默认加载">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.skuDefaultDownload" :inactive-value="0" :active-value='1' @change="setDownloadTemplateGroup(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" v-if="!addCorrelation" label="是否默认使用">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.defaultUse" @change="setDefaultTemplateGroup(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">addSkuStep <template slot-scope="scope">
            <span class="color-blue" v-show="addCorrelation && !scope.row.xrefId" @click="Correlation(scope.row)">关联</span>
            <span class="color-blue" v-show="!addCorrelation || (addCorrelation && scope.row.xrefId)" @click="cancelCorrelation(scope.row)">取消关联</span>
            <div class="upload-pdf">
              <input type="file" ref="pdfInput" name="pdf_file" accept=".pdf,application/pdf" style="display:none;" @change="uploadPdfFile($event, scope.row)" />
              <span :class="{ 'color-blue': !scope.row.pdfUrl }" @click="triggerPdfUpload($event, scope.row)">上传扉页通用烫金文件</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <v-pagination class="v-pagination" :queryInfo="tempQueryInfo" @changePage="changePage"></v-pagination>
      <el-dialog :close-on-click-modal="false" width="900px" title="查看模板" :visible.sync="checkTemplateDialog" append-to-body>
        <div style="display: flex;flex-direction:row;flex-wrap:wrap;width:900px">
          <div v-for="item in templateList" :key="item.id + item.sorting">
            <img style="width:150px;margin:0 5px 5px 0;border:2px solid #000" :src="item.templateThumbnail" alt="">
            <div style="width:150px;text-align: center;margin-bottom: 10px;">{{ item.pageTypeCode ? item.pageTypeCode === 'TEXT' ? '内页' : item.pageTypeCode === 'COVER' ? '封面' : '单页' : '' }}</div>
          </div>
        </div>
        <!-- <div>{{ item.pageTypeCode }}</div> -->
      </el-dialog>
    </el-dialog>
    <!-- 添加sku -->
    <el-dialog :close-on-click-modal="false" title="SKU设置" @closed="closed" @opened="$refs.formaaa.clearValidate()" :visible.sync="addSkuDialog" width="800px">
      <el-form ref="formaaa" v-show="addSkuStep === 1" :rules="step1Rules" :model="skuMsg" label-width="180px">
        <!-- @click.native="closed" -->
        <el-form-item label="SKU名字：" prop="skuName">
          <el-input v-model="skuMsg.skuName" placeholder="" style="width:300px;" :disabled="isEditSku === 'check'"></el-input>
          <!-- <span v-else>{{skuMsg.skuName}}</span> -->
        </el-form-item>
        <el-form-item label="SKU前端显示名字：" prop="skuFrontName">
          <el-input v-model="skuMsg.skuFrontName" placeholder="" style="width:300px;" :disabled="isEditSku === 'check'"></el-input>
          <!-- <span v-else>{{skuMsg.skuFrontName}}</span> -->
        </el-form-item>
        <el-form-item label="尺寸组：">
          <span v-if="skuMsgName">{{ skuMsgName }}</span>
          <el-button type="primary" style="margin-left:20px" @click="type = 'sku', getSizeGroupList(), sizeDialog = true" round v-if="isEditSku !== 'check' && !isdisabled">选择尺寸组 </el-button>
        </el-form-item>
        <el-form-item label="页面名称：">
          <el-table :data="pageNameTableData" style="width: 500px">
            <el-table-column prop="pageName" label="页面名称"></el-table-column>
            <el-table-column prop="typeName" label="页面类型">
              <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input v-if="scope.row.isEditable" @input="countP" style="width:100px" v-model="scope.row.pageNum" placeholder="" :disabled="isEditSku === 'check'">
                </el-input>
                <span v-if="!scope.row.isEditable">{{ scope.row.pageNum }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="用户应上传照片张数 :" prop="uploadPhotoNum" v-if="skuMsg.spuType === 'photo'">
          <div v-if="isEditSku !== 'check' && !isdisabled">
            <el-input v-model="skuMsg.uploadPhotoNum" placeholder=""></el-input>张
          </div>
          <span v-else>{{ skuMsg.uploadPhotoNum ? skuMsg.uploadPhotoNum : skuMsg.basePage }}g</span>
        </el-form-item>
        <el-form-item label="重量:" prop="weight">
          <div v-if="isEditSku !== 'check' && !isdisabled">
            <el-input v-model="skuMsg.weight" placeholder=""></el-input>g
          </div>
          <span v-else>{{ skuMsg.weight }}g</span>
        </el-form-item>
        <el-form-item label="是否合成半P:" prop="isComposeHalfP" v-if="skuMsg.spuType == 'photo'">
          <el-radio-group v-model="skuMsg.isComposeHalfP">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封面合成位置:" prop="coverPosition">
          <el-select v-model="skuMsg.coverPosition" value-key="id" placeholder="请选择" clearable :disabled="isEditSku === 'check'">
            <el-option label="首页" value="FIRST_PAGE"></el-option>
            <el-option label="尾页" value="LAST_PAGE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面合成坐标:" prop="param"> 左：<el-input type="number" :disabled="isEditSku === 'check'" style="width:200px" v-model="skuMsg.leftParam" placeholder=""><template
              slot="append">mm</template>
          </el-input> 上：<el-input style="width:200px" :disabled="isEditSku === 'check'" type="number" v-model="skuMsg.topParam" placeholder=""><template slot="append">mm</template></el-input>
        </el-form-item>
        <el-form-item label="是否为0元购产品:" prop="isZeroPurchase">
          <el-radio-group v-model="skuMsg.isZeroPurchase" :disabled="$route.query.onSale == 'true' ? true : false">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="照片张数是否限制:" prop="limitQuantity">
          <el-radio-group v-model="skuMsg.limitQuantity">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否特殊效果:" prop="specialPrint">
          <el-radio-group v-model="skuMsg.specialPrint">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="基础P数：" prop="basePage">
          <span @click="asd">{{ skuMsg.basePage }}</span>
        </el-form-item>
        <el-form-item label="一次增加P数：" prop="baseStep">
          <el-input v-model.number="skuMsg.baseStep" placeholder="" v-if="isEditSku !== 'check' && !isdisabled"></el-input>
          <span v-else>{{ skuMsg.baseStep }}</span>
        </el-form-item>
        <el-form-item label="最大P数：" prop="maxPage">
          <el-input v-model.number="skuMsg.maxPage" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.maxPage }}</span>
        </el-form-item>
        <div style="display: flex;">
          <el-form-item label="基础P平台价格：" prop="basePagePrice">
            <el-input v-model="skuMsg.basePagePrice" @input="changeBasePagePrice" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)">
            </el-input>
          </el-form-item>
          <el-form-item label="基础P积分价格：" prop="basePagePoints" v-if="$route.query.showPoint == 'true'">
            <el-input v-model="skuMsg.basePagePoints" @input="changeBasePagePoints" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)">
            </el-input>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="增加一次平台价格：" prop="baseStepPrice">
            <!-- isEditSku === 'check' || disable || isdisabled -->
            <el-input v-model="skuMsg.baseStepPrice" @input="changeBaseStepPrice" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)"></el-input>
          </el-form-item>
          <el-form-item label="增加一次积分价格：" prop="baseStepPoints" v-if="$route.query.showPoint == 'true'">
            <!-- isEditSku === 'check' || disable || isdisabled -->
            <el-input v-model="skuMsg.baseStepPoints" @input="changeBaseStepPoints" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="基础P在线支付价格：" prop="onlineSalePrice" v-if="$route.query.showPoint != 'true'">
          <el-input v-model="skuMsg.onlineSalePrice" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)"></el-input>
        </el-form-item>
        <!-- :disabled="isEditSku === 'check' || disable || isdisabled" -->
        <el-form-item label="增加一次在线支付价格：" prop="onlineBaseStepPrice" v-if="$route.query.showPoint != 'true'">
          <el-input v-model="skuMsg.onlineBaseStepPrice" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)"></el-input>
        </el-form-item>
        <!-- 新加的 -->
        <el-form-item label="基础P初创平台价格：" prop="startupsBasePagePrice" v-if="startupsSpu == 'true'">
          <el-input v-model="skuMsg.startupsBasePagePrice" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)"></el-input>
        </el-form-item>
        <el-form-item label="增加一次初创平台价格：" prop="startupsBaseStepPrice" v-if="startupsSpu == 'true'">
          <el-input v-model="skuMsg.startupsBaseStepPrice" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)"></el-input>
        </el-form-item>
        <el-form-item label="基础P推荐终端价格：" prop="terminalSalePrice">
          <el-input v-model="skuMsg.terminalSalePrice" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)"></el-input>
        </el-form-item>
        <el-form-item label="增加一次推荐终端价格：" prop="terminalStepSalePrice">
          <!-- isEditSku === 'check' || isdisabled -->
          <el-input v-model="skuMsg.terminalStepSalePrice" placeholder="" :disabled="singlePrice ? haveSkuList : (isEditSku === 'check' || isdisabled)"></el-input>
        </el-form-item>
        <!-- <el-form-item label="批量数量：" prop="">
          <el-input v-model="skuMsg.onlineBaseStepPrice" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="批量价格：" prop="">
          <el-input v-model="skuMsg.onlineBaseStepPrice" placeholder=""></el-input>
        </el-form-item> -->
      </el-form>
      <el-tabs v-if="addSkuStep === 2" v-model="activeName">
        <el-tab-pane v-for="(item, index) in pageNameTableData" :key="item.id + item.pageName" :label="$store.state.pms.pageType[item.pageTypeCode] + '设置'" :name="'a' + index">
          <div class="settextbox">
            <p>
              <!-- 最大P数：{{item.pageTypeCode==='SINGLE'?skuMsg.singlePage:item.pageTypeCode==='COVER'?skuMsg.coverPage:+item.pageNum===+skuMsg.basePage?skuMsg.maxPage:+skuMsg.maxPage - +skuMsg.coverPage}}P -->
              <!-- 增加的P数都是内页增加的，其余都固定 --> 最大P数：{{ item.pageTypeCode !== 'TEXT' ? item.pageNum : +item.pageNum + (+skuMsg.maxPage - +skuMsg.basePage) }}P
            </p>
            <p>
              <!-- 最小P数：{{item.pageTypeCode==='SINGLE'?item.pageNum:item.pageTypeCode==='COVER'?skuMsg.coverPage:+item.pageNum===+skuMsg.basePage?skuMsg.basePage:+skuMsg.basePage - +skuMsg.coverPage}}P -->
              最小P数：{{ item.pageNum }}P
            </p>
            <p>1P=2页</p>
          </div>
          <el-form ref="form" :model="item" label-width="200px">
            <el-form-item v-for="(bar, index2) in item.barCodeList" :key="bar.id + index2" :label="bar.barName + '出现位置：'">
              <el-select v-model="skuMsg.skuPageSettingVOList[index].barCodePositionList[index2].barCodePosition" placeholder="" clearable :disabled="isEditSku === 'check'" @change="selectChange">
                <el-option v-for="pos in item.barPosition" :key="pos.id + pos.dictValue" :label="pos.dictValue" :value="pos.dictCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="不进入合成页序：">
              <el-input style="width:50px" v-model="skuMsg.skuPageSettingVOList[index].noComposePageNumStart" :disabled="isEditSku === 'check'">
              </el-input> 到 <el-input style="width:50px;margin-left:10px" v-model="skuMsg.skuPageSettingVOList[index].noComposePageNumEnd" :disabled="isEditSku === 'check'">
              </el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入不进入合成的页序区间，已确定不<br />进入合成的页序，将会锁定不可编辑，<br>不可调序，使用”,“隔开。</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="合成后要删除的页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].deletePage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入合成后要删除的页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="item.typeName !== '封面'" label="不可排序页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].noAllowSortPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入不可排序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="不可编辑页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].noAllowEditPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入不可编辑页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="封面通用文件页序：" v-if="!skuMsg.specialPrint && ($store.state.pms.pageType[item.pageTypeCode] == '封面')">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].generalFilePage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入封面通用文件页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="pdf页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].pdfPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入pdf页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="扉页通用烫金PDF页序：" v-if="$store.state.pms.pageType[item.pageTypeCode] == '内页'">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].titlePagePdfPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入扉页通用烫金PDF页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="只读页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].readonlyPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入只读页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="半页不可编辑页序：">
              <i class="el-icon-circle-plus" @click="addPageVOS(index)" style="font-size: 18px;"></i>
              <div v-for="(a, b) in skuMsg.skuPageSettingVOList[index].skuPageSettingHalfPageVOS" :key="b" style="display:flex;margin-top: 10px;">
                <el-select v-model="a.sort" placeholder="请选择" clearable :disabled="isEditSku === 'check'">
                  <el-option label="正序" :value="0"></el-option>
                  <el-option label="倒序" :value="1"></el-option>
                </el-select>
                <el-input v-model="a.noAllowEditPage" :disabled="isEditSku === 'check'" placeholder="请输入页序" style="margin-left:20px"></el-input>
                <el-select v-model="a.position" placeholder="请选择" clearable :disabled="isEditSku === 'check'">
                  <el-option label="左" :value="0"></el-option>
                  <el-option label="右" :value="1"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <!-- 以下新加 -->
            <el-form-item label="是否拆分pdf:">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].splitPdf" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                :disabled="isEditSku === 'check'"></el-switch> </el-form-item>
            <el-form-item label="银卡拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageYk" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageYkDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="透片拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTp" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTpDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="磨砂透片拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMstp" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMstpDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫哑金拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTjuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTjuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫亮金拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTljuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTljuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫镭射银拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsyuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsyuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫镭射金拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsjuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsjuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="MGI镭射银卡UV拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMGIYuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMGIYuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="牛皮纸拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageNpz" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageNpzDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="其他拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageQt" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageQtDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="是否镜像:">
              <el-radio-group v-model="skuMsg.skuPageSettingVOList[index].flip" :disabled="isEditSku === 'check'">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">水平翻转</el-radio>
                <el-radio :label="2">垂直翻转</el-radio>
                <el-radio :label="3">同时翻转</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="全部页:" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].flipAllPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 1)" :disabled="isEditSku === 'check'"></el-switch>
            </el-form-item>
            <el-form-item label="偶数页:" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].flipEvenPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 2)" :disabled="isEditSku === 'check'"></el-switch>
            </el-form-item>
            <el-form-item label="奇数页:" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].flipOddPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 3)" :disabled="isEditSku === 'check'"></el-switch>
            </el-form-item>
            <el-form-item label="指定页：" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].flipSpecifyPage" :disabled="isEditSku === 'check'" @change="switchChange($event, index, 4)"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="addSkuStep === 1" type="primary" @click="addSkuNextStep()">下一步</el-button>
        <el-button v-show="addSkuStep === 2" type="primary" @click="addSkuStep = 1">上一步</el-button>
        <el-button v-show="addSkuStep === 2" type="primary" @click="confirmAddSku">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 绑定尺寸组 -->
    <el-dialog :close-on-click-modal="false" title="统一关联尺寸组" :visible.sync="sizeDialog" width="60%">
      <el-form :inline="true" :model="searchComposeSizeGroupVO" class="demo-form-inline">
        <el-form-item label="尺寸组类:">
          <el-select v-model="searchComposeSizeGroupVO.groupCategoryId" placeholder="" clearable>
            <el-option v-for="item in sizeGroupTypeList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="尺寸组名称：">
          <el-input v-model="searchComposeSizeGroupVO.groupName" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button round @click="getSizeGroupList">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="sizeGroupList" border>
        <el-table-column type="expand">
          <template v-slot='scope'>
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.detail.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型" prop="typeName">
                  <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
                </el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight
                  }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                </el-table-column>
                <el-table-column label="码" prop="barCodeId">
                  <template slot-scope="scope">
                    <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="groupCategoryName" min-width="100px"></el-table-column>
        <el-table-column label="页面名称" prop="detail.pageName" min-width="100px">
          <template slot-scope="scope"> {{ scope.row.pageName.substring(0, scope.row.pageName.length - 1) }} </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100px">
          <template slot-scope="scope">
            <span class="color-blue" @click="relation(type, scope.row)">选择</span><br>
          </template>
        </el-table-column>
      </el-table>
      <v-pagination class="v-pagination" :queryInfo="sizeGroupQueryInfo" @changePage="sizeGroupchangePage"></v-pagination>
    </el-dialog>
    <!-- 确认删除 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="deleteSkuDialog" width="30%">
      <p>是否确定删除？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteSkuDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteSku()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加样品主题 -->
    <el-dialog :close-on-click-modal="false" title="请输入样品编码" :visible.sync="addSampleTheme" @closed="sampleBarCode = ''" width="30%">
      <el-input v-model="sampleBarCode" placeholder=""></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addTheme" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上传样品文件 -->
    <el-dialog :close-on-click-modal="false" title="上传文件" :visible.sync="upLoadSampleTheme" @closed="closeSampleTheme" width="500px" v-if="upLoadSampleTheme">
      <el-form :inline="true" :model="sampleThemeForm" class="demo-form-inline">
        <el-form-item label="选择sku:" style="width:100%">
          <el-select clearable v-model="sampleThemeForm.skuId" filterable placeholder="请输入sku名称" @change="skuIdChange">
            <el-option v-for="item in selectSkuList" :key="item.id" :label="item.skuName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传样片文件:" style="width:100%">
          <!-- <el-upload ref="handleUpload" action="#" :http-request="unloadAccessory" :before-upload="handleBeforeUpload" :show-file-list="false" multiple>
            <el-button size="small" type="primary" @click="handleAddFolder">点击上传</el-button>
          </el-upload> -->
          <el-button size="small" type="primary" @click="handleAddFolder">点击上传</el-button>
          <div class="el-upload__tip" v-if="!fileName">只能上传文件夹</div>
          <div class="el-upload__tip" v-else>已上传:{{ fileName }}</div>
          <input type="file" webkitdirectory @change="handleFiles" style="display: none" ref="fileInput" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addThemeFile" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="确认提示" border :visible.sync="hintDialog" width="500px"> 添加sku前请统一关联尺寸组 <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hintDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 错误提示 -->
    <el-dialog :close-on-click-modal="false" title="错误提示" border :visible.sync="tipDialog" width="500px"> <span v-if="!basicInfo.isPdf">模板数量应大于sku最大P数</span><span v-else>模板数量应大于模板页总页数</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <adminPickCollTemplate ref="adminPickCollTemplate" />
    <!-- 轮播（预览） -->
    <el-dialog :visible.sync="imgViewerVisible" width="50%" class="dialog" v-if="imgViewerVisible" :fullscreen="isFull" :showClose="false">
      <template slot="title">
        <div style="display:flex; justify-content:space-between;">
          <div>{{ itemImgs.name }}</div>
          <div style="display:flex;">
            <img src="../../../assets/images/page-big.png" width="18px" alt="" @click="isFull = true" v-if="!isFull" />
            <img src="../../../assets/images/page-small.png" width="18px" alt="" @click="isFull = false" v-else />
            <img src="../../../assets/images/close.png" width="18px" alt="" style="margin-left:20px;" @click="imgViewerVisible = false" />
          </div>
        </div>
      </template>
      <div style="text-align: center;width: 100%;">{{ itemImgs.index }}/{{ imageList.length }}</div>
      <div class="dialog-box">
        <div class="switch-btn" @click="onClickCarousel('prev')"><img src="../../../assets/images/carousel-left.png" width="30px" /></div>
        <el-carousel :interval="5000" arrow="never" class="switch-box" :indicator-position="'none'" ref="el-carousel" :loop="false" :autoplay="false" height="400px" @change="carouselChange">
          <!-- <el-carousel-item class="switch" v-if="!isOneLoad"><img :src="UserLookList[0].thumbnailUrl + '?x-sds-process=image/resize,l_160,m_mfit'" @load="changeLoad" />
              </el-carousel-item> -->
          <el-carousel-item v-for="(item, index) in imageList" :key="index" class="switch"><img :src="item.imageUrl" />
          </el-carousel-item>
        </el-carousel>
        <div class="switch-btn" @click="onClickCarousel('next')"><img src="../../../assets/images/carousel-right.png" width="30px" /></div>
      </div>
      <!-- <div class="dialog-btn"><p class="submit" @click="onSubmit" v-if="detailOrder.totalOprt === detailOrder.totalCustomer">确认</p> </div> -->
    </el-dialog>
  </div>
</template>
<script>
import adminPickCollTemplate from './adminPickCollTemplate.vue'
import VPagination from '@/components/Pagination/index.vue'
import { groupCategoryList, skuAssociateTemplateGroup, setDownloadTemplateGroup, setDefaultTemplateGroup, getGroupListBySkuId, spuHasWhitePage, skuSpecialPriceDeleteBySpecialId, skuUsable, skuUpdate, skuGroupDetail, dictQueryByPid, skuGroupUpdateCurrency, skuSampleDelete, skuSampleSave, groupSkuRelateGroup, composeGroupDetail, skuGroupUpdate, skuDelete, skuAdd, barCodePosition, groupListPageing, groupQueryGroupById, groupGetGroupList, propertyGetPropertyList, sampleListNoPaging, skuGroupAudit, skuSpecialStoreList, getGroupListForSkuRelate, updateSkuMainImage, saveSampleImage, previewSampleImage, updateSkuPdfUrl, updateByGroupSkuXrefId } from '@/api/pms'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import { findCloseNum } from '@/utils/transitionFile.js'
import ExifReader from 'exifreader'
import SortLikeWin from '@/utils/sortFile.js'
import { getPointRules } from '@/api/crm'
export default {
  name: 'sku-details',
  components: {
    VPagination, adminPickCollTemplate
  },
  data () {
    var checkBaseStep = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入大于等于0的值'))
      } else {
        if (+value === 0) {
          callback(new Error('步长最小为1'))
        }
        callback()
      }
    }
    var checkPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入样品价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('样品价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkBasePagePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入基础P价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('基础P价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkBasePagePoints = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else if (!this.$reg.checkInteger.reg.test(value)) {
        callback(new Error('基础P积分价格' + this.$reg.checkInteger.message))
      } else {
        callback()
      }
    }
    var checkBaseStepPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入增加一次价格'))
      } else if (!this.$reg.elsePrice.reg.test(value)) {
        callback(new Error('增加一次价格' + this.$reg.elsePrice.message))
      } else {
        callback()
      }
    }
    var checkBaseStepPoints = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else if (!this.$reg.checkInteger.reg.test(value)) {
        callback(new Error('增加一次积分价格' + this.$reg.checkInteger.message))
      } else {
        callback()
      }
    }
    var terminalSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入基础P推荐终端价格：'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('基础P推荐终端价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var onlineBaseStepPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入增加一次在线支付价格'))
      } else if (!this.$reg.elsePrice.reg.test(value)) {
        callback(new Error('增加一次在线支付价格' + this.$reg.elsePrice.message))
      } else {
        callback()
      }
    }
    var terminalStepSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入增加一次推荐终端价格'))
      } else if (!this.$reg.elsePrice.reg.test(value)) {
        callback(new Error('增加一次推荐终端价格' + this.$reg.elsePrice.message))
      } else {
        callback()
      }
    }
    var checkSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入最低终端价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('最低终端价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var onlineSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入在线支付价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('在线支付价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var startupsBasePagePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入初创平台价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('初创平台价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var startupsBaseStepPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入增加一次初创平台价格'))
      } else if (!this.$reg.elsePrice.reg.test(value)) {
        callback(new Error('增加一次初创平台价格' + this.$reg.elsePrice.message))
      } else {
        callback()
      }
    }
    var skuName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入sku名字'))
      } else if (this.$reg.skuName.reg.test(value)) {
        callback(new Error(this.$reg.skuName.message))
      } else {
        callback()
      }
    }
    var skuFrontName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入sku前端显示名字'))
      } else if (this.$reg.skuName.reg.test(value)) {
        callback(new Error(this.$reg.skuName.message))
      } else {
        callback()
      }
    }
    return {
      startupsSpu: this.$route.query.startupsSpu, // 是否初创产品
      isFull: false,
      imgViewerVisible: false, // 预览show
      imageList: [],
      itemImgs: {
        name: '',
        index: 0
      },
      sampleThemeId: null,
      fileName: '',
      uploadImgsList: ['111'],
      upLoadImgList: [],
      sampleThemeForm: {},
      upLoadSampleTheme: false,
      selectSkuList: [], // 选择sku
      selectSkuListItem: [],
      haveSkuList: false, // 是否存在skuList
      isdisabled: false,
      addLock: false,
      hintDialog: false,
      limitTime: '',
      sampleBarCode: '',
      addSampleTheme: false,
      step1Rules: {
        uploadPhotoNum: [{ required: true, message: '请填写用户应上传照片张数', trigger: 'change' }],
        weight: [{ required: true, message: '请填写重量', trigger: 'change' }],
        skuName: [
          { required: true, validator: skuName, trigger: 'blur' }
        ],
        skuFrontName: [
          { required: true, validator: skuFrontName, trigger: 'blur' }
        ],
        basePage: [
          { required: true, message: '请选择尺寸组', trigger: 'change' }
        ],
        baseStep: [
          { required: true, validator: checkBaseStep, trigger: 'blur' },
          { type: 'number', min: 0, message: '请输入大于等于0的值' }
        ],
        maxPage: [
          { required: true, message: '请输入最大P数', trigger: 'blur' },
          { type: 'number', min: 0, message: '请输入大于等于0的值' }
        ],
        basePagePrice: [
          { required: true, validator: checkBasePagePrice, trigger: 'blur' }
        ],
        basePagePoints: [
          { required: false, validator: checkBasePagePoints, trigger: 'blur' }
        ],
        baseStepPrice: [
          { required: true, validator: checkBaseStepPrice, trigger: 'blur' }
        ],
        baseStepPoints: [
          { required: false, validator: checkBaseStepPoints, trigger: 'blur' }
        ],
        onlineSalePrice: [
          { required: true, validator: onlineSalePrice, trigger: 'blur' }
        ],
        startupsBasePagePrice: [
          { required: true, validator: startupsBasePagePrice, trigger: 'blur' }
        ],
        onlineBaseStepPrice: [
          { required: true, validator: onlineBaseStepPrice, trigger: 'blur' }
        ],
        startupsBaseStepPrice: [
          { required: true, validator: startupsBaseStepPrice, trigger: 'blur' }
        ],
        terminalSalePrice: [
          { required: true, validator: terminalSalePrice, trigger: 'blur' }
        ],
        terminalStepSalePrice: [
          { required: true, validator: terminalStepSalePrice, trigger: 'blur' }
        ]
        // salePrice: [
        //   { required: true, validator: checkSalePrice, trigger: 'blur' }
        // ]
      },
      rules: {
        skuGroupName: [
          { required: true, message: '请输入SKU组名称', trigger: 'blur' }
        ],
        skuGroupImage: [
          { required: true, message: '请上传SKU组图片', trigger: 'blur' }
        ]
      },
      dictList: [],
      addCorrelationType: '',
      selectTemplateList: [],
      addCorrelationSkuId: '',
      addCorrelation: false,
      deleteSkuMsg: null,
      deleteSkuDialog: false,
      isEditSku: false,
      barPosition: {
        cover: {
          has: [],
          none: []
        },
        page: {
          has: [],
          none: []
        }
      },
      activeName: 'a0',
      sizeGroupList: [],
      sizeGroupQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      templateList: [],
      checkTemplateDialog: false,
      templateGroupList: [],
      allPropertyList: [],
      propertyList: [],
      value: [],
      searchGroupVo: {
        auditStatus: '',
        composeSizeGroupId: '',
        createTimeBegin: '',
        createTimeEnd: '',
        groupBelong: '',
        groupName: '',
        isAssociatedeSizeGroup: '',
        page: 1,
        propertyId: '',
        skuId: '',
        templateThemeId: ''
      },
      templateDialog: false,
      sizeGroupTypeList: [],
      searchComposeSizeGroupVO: {
        groupCategoryId: '',
        groupName: '',
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : ''
      },
      sizeDialog: false,
      addSkuStep: 1,
      status: this.$route.query.auditStatus,
      editPriceDialog: false,
      onlineSamplePriceDialog: false,
      startupsSamplePriceDialog: false,
      editePointsDialog: false,
      basicInfo: {
        skuList: [],
        isTimeLimit: false,
        isSingleSkuGroup: false
        // samplePoints: ''
      },
      pageNumLock: false,
      specialPriceData: [{
        platformNum: '',
        platformName: '',
        salesman: '',
        operation: {
          check: '查看',
          delete: '删除'
        }
      }],
      priceTableList: [],
      isShow: false,
      editPrice: '',
      specialStoreList: [],
      checkDialog: false,
      haddleSizeGroupDialog: false,
      checkSizeGroupTableData: [{
        groupName: '',
        sizeList: []
      }],
      addSkuDialog: false,
      skuMsg: {
        isComposeHalfP: false,
        isZeroPurchase: false,
        limitQuantity: true,
        specialPrint: 0,
        coverPosition: '',
        leftParam: '',
        topParam: '',
        isHavePromoCode: '',
        basePage: 0,
        basePagePrice: 0,
        basePagePoints: 0,
        baseStep: 1,
        baseStepPrice: 0,
        baseStepPoints: 0,
        onlineSalePrice: 0,
        startupsBasePagePrice: 0,
        onlineBaseStepPrice: 0,
        startupsBaseStepPrice: 0, // 初创平台步长
        terminalSalePrice: 0,
        terminalStepSalePrice: 0,
        composeSizeGroupId: 0,
        maxPage: 0,
        skuName: '',
        skuFrontName: '',
        coverPage: '',
        skuPageSettingVOList: [
          {
            noAllowEditPage: '',
            deletePage: '',
            noAllowSortPage: '',
            generalFilePage: '',
            titlePagePdfPage: '',
            pdfPage: '',
            readonlyPage: '',
            skuPageSettingHalfPageVOS: [
              {
                sort: null,
                noAllowEditPage: '',
                position: null
              }
            ],
            noComposePageNumEnd: 0,
            noComposePageNumStart: 0,
            skuPageType: '',
            splitPdf: 0,
            splitPageYk: '',
            splitPageYkDesc: '',
            splitPageTp: '',
            splitPageTpDesc: '',
            splitPageMstp: '',
            splitPageMstpDesc: '',
            splitPageTjuv: '',
            splitPageTjuvDesc: '',
            splitPageTljuv: '',
            splitPageTljuvDesc: '',
            splitPageTlsyuv: '',
            splitPageTlsyuvDesc: '',
            splitPageTlsjuv: '',
            splitPageTlsjuvDesc: '',
            splitPageMGIYuv: '',
            splitPageMGIYuvDesc: '',
            splitPageNpz: '',
            splitPageNpzDesc: '',
            splitPageQt: '',
            splitPageQtDesc: '',
            flip: 0,
            flipAllPage: 0,
            flipEvenPage: 0,
            flipOddPage: 0,
            flipSpecifyPage: ''
          }
        ]
      },
      isComposeHalfP: false,
      disable: false,
      singlePrice: false,
      isDiy: null,
      maxPage: 0, // sku最大P数
      tipDialog: false,
      skuMsgName: '',
      pageNameTableData: [],
      sampleList: [],
      selectSample: '',
      tempQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      defaultSizeGroup: null,
      basePagePointsEdited: false,
      baseStepPointsEdited: false,
      pointExchangeRote: 0
    }
  },
  async created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    await this.getSkuGroupMsg()
    this.getSizeGroupTypeList()
    this.getBarPositionList()
    this.SampleList()
    this.getFormatList()
    this.$store.dispatch('pms/getPageTypeList')
    console.log('this.skuMsg+created', this.skuMsg)
    if (this.$route.query.showPoint == 'true') {
      this.getUserPointExchangeRote()
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  watch: {
    value (val) {
      if (val) {
        this.searchGroupVo.createTimeBegin = val[0]
        this.searchGroupVo.createTimeEnd = val[1]
      } else {
        this.searchGroupVo.createTimeBegin = ''
        this.searchGroupVo.createTimeEnd = ''
      }
    }
  },
  methods: {
    getUserPointExchangeRote () {
      getPointRules('WD').then(res => {
        if (res.data.success) {
          this.pointExchangeRote = res.data.data.exchangeRate
        }
      })
    },
    changeBasePagePrice () {
      console.log('changeBasePagePrice')
      if (this.basePagePointsEdited) {
        this.$forceUpdate()
        return
      }
      if (!this.pointExchangeRote) {
        this.$forceUpdate()
        return
      }
      this.skuMsg.basePagePoints = Math.round(this.skuMsg.basePagePrice * this.pointExchangeRote)
      this.$forceUpdate()
    },
    changeBasePagePoints () {
      this.basePagePointsEdited = true
      this.$forceUpdate()
    },
    changeBaseStepPrice () {
      console.log('changeBasePagePrice')
      if (this.baseStepPointsEdited) {
        this.$forceUpdate()
        return
      }
      if (!this.pointExchangeRote) {
        this.$forceUpdate()
        return
      }
      this.skuMsg.baseStepPoints = Math.round(this.skuMsg.baseStepPrice * this.pointExchangeRote)
      this.$forceUpdate()
    },
    changeBaseStepPoints () {
      this.baseStepPointsEdited = true
      this.$forceUpdate()
    },
    addPageVOS (index) {
      this.skuMsg.skuPageSettingVOList[index].skuPageSettingHalfPageVOS.push(
        {
          sort: null,
          noAllowEditPage: '',
          position: null
        })
    },
    switchChange (value, index, type) {
      if (type == 1 && value == 1) {
        this.skuMsg.skuPageSettingVOList[index].flipEvenPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipOddPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipSpecifyPage = ''
      } else if (type == 2 && value == 1) {
        this.skuMsg.skuPageSettingVOList[index].flipAllPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipOddPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipSpecifyPage = ''
      } else if (type == 3 && value == 1) {
        this.skuMsg.skuPageSettingVOList[index].flipAllPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipEvenPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipSpecifyPage = ''
      } else if (type == 4 && value) {
        this.skuMsg.skuPageSettingVOList[index].flipAllPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipEvenPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipOddPage = 0
      }
    },
    // 点击上传按钮
    handleAddFolder () {
      // this.$nextTick(() => {
      //   // this.uploadImgsList = []
      //   this.$refs.handleUpload.$children[0].$refs.input.webkitdirectory = true
      // })
      this.$refs.fileInput.click()
    },
    // 上传文件夹
    async handleFiles (event) {
      console.log('event', event.target.files)
      const files = []
      let filesList = []
      for (let key in event.target.files) {
        console.log('key', key)
        if (key !== 'length' && key !== 'item') {
          let file = event.target.files[key]
          filesList.push(file)
        }
      }
      filesList.forEach(a => {
        if (a.name.split('.').pop() != 'db') {
          files.push(a)
        }
      })
      console.log('files.length', files.length)

      // 过滤出隐藏文件
      // const files = files1.filter(a => a.name.split('.').pop() != 'db')
      if (files.length === 0) {
        return
      }
      console.log('this.sampleThemeForm.skuId', this.sampleThemeForm.skuId, this.selectSkuList)
      let item = this.selectSkuList.find(a => a.id == this.sampleThemeForm.skuId)
      console.log('item', item)
      let coverPageNum = item.coverPage ? item.coverPage : 0
      let minPage = item?.basePage + coverPageNum
      let maxPage = item?.maxPage + coverPageNum
      let coverPageList = files.filter(a => a.name.includes('封面'))
      if (coverPageList.length !== coverPageNum) {
        this.$message.error('上传图片封面数量与当前sku的封面页数不一致')
        return
      }
      let upLoadImgLength = files.length
      console.log('item', item)
      // 验证上传图片数量与实际需要上传数量是否一致
      if (maxPage == minPage) {
        if (upLoadImgLength !== minPage) {
          this.$message.error('上传图片数量与当前sku的P数不一致')
          return
        }
      } else {
        if (upLoadImgLength > maxPage) {
          this.$message.error('上传图片数量不能大于最大P数')
          return
        }
        if (upLoadImgLength < minPage) {
          this.$message.error('上传图片数量不能小于最小P数')
          return
        }
      }
      files.sort(SortLikeWin)
      // 将封面排在最前面
      // let obj = {}
      // files.forEach((item, index) => {
      //   if (item.name.slice(0, item.name.lastIndexOf('.')) === '封面') {
      //     obj = item
      //     files.splice(index, 1)
      //     return true
      //   }
      // })
      // if (obj.name) {
      //   files.unshift(obj)
      // }
      // 将封面排在最前边（多个封面）
      let coverPage = files.filter(a => a.name.includes('封面'))
      let insidePage = files.filter(a => !a.name.includes('封面'))
      let filesNew = coverPage.concat(insidePage)
      console.log('filesNew', filesNew)
      this.loading = this.$loading({
        lock: true,
        text: '正在上传文件夹，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      console.log('files', files)
      this.fileName = ''
      let that = this
      that.upLoadImgList = []
      that.imageAssemble(filesNew, 0, item)
      this.$refs.fileInput.value = null
    },
    // 图片组装
    imageAssemble (files, i, item) {
      let that = this
      // 页面类型:封面-COVER 内页-TEXT 单页-SINGLE
      ExifReader.load(files[i]).then(async (tags) => {
        console.log('tagsssss', tags)
        if (!tags.XResolution) {
          that.$message.error('您提交的图片不符合要求，请重新调整后再上传')
          that.loading.close()
          return
        }
        // 新增:为了解决读取出来的格式是3000000/10000
        if (tags.XResolution?.description.includes('/')) {
          tags.XResolution.description = that.convertToPixels(tags.XResolution.description)
          console.log('tags.XResolution.description', tags.XResolution.description)
        }
        if (tags.YResolution?.description.includes('/')) {
          tags.YResolution.description = that.convertToPixels(tags.YResolution.description)
          console.log('tags.YResolution.description', tags.YResolution.description)
        }
        let rotateValue = tags.Orientation?.value
        let img = {
          width: tags['Image Width'].value,
          height: tags['Image Height'].value,
          xdpi: tags.XResolution?.description || 96,
          ydpi: tags.YResolution?.description || 96,
          // ColorSpace: tags['Color Space'] ? tags['Color Space'] : tags.ColorSpace
          rotate: rotateValue ? (rotateValue == 8 ? 270 : rotateValue == 6 ? 90 : rotateValue == 1 ? 0 : rotateValue == 3 ? 180 : 0) : 0,
          color: tags['Color Components']?.description
        }
        var pageTypeCodeName = 'TEXT'
        if (item.skuPageSettingList.length == 1) {
          pageTypeCodeName = item.skuPageSettingList[0].skuPageType
        } else if (item.skuPageSettingList.length == 2) {
          pageTypeCodeName = files[i].name.includes('封面') ? 'COVER' : 'TEXT'
        }
        let spuDpi = findCloseNum([254, 300], +img.xdpi)
        let itemCheck = this.checkPageSize(
          i,
          files,
          (img.width / spuDpi) * 25.4,
          (img.height / spuDpi) * 25.4,
          img.xdpi,
          img.ydpi,
          pageTypeCodeName,
          img.color,
          spuDpi,
          img.rotate
        )
        if (itemCheck.error) {
          console.log('error', pageTypeCodeName, itemCheck.error)
          that.loading.close()
          that.$message.error(itemCheck.error)
          return
        }
        await uploadWebImg(files[i], that.$store.state.awsSdk.product.s3).then(res => {
          console.log('resresresres', res)
          // if (that.basicInfo.specialLayout && ((files[0].name == '封面' && i == 1) || (files[0].name !== '封面' && i == 0) || (i == (files.length - 1)))) {
          //   if ((files[0].name == '封面' && i == 1) || (files[0].name !== '封面' && i == 0)) {
          //     // 首页
          //     that.upLoadImgList.push({
          //       sorting: i,
          //       url: res,
          //       imageName: files[i].name,
          //       pageTypeCode: pageTypeCodeName,
          //       specialLayout: true,
          //       specialLayoutWhitePagePosition: 'LEFT'
          //     })
          //   } else {
          //     // 尾页
          //     that.upLoadImgList.push({
          //       sorting: i,
          //       url: res,
          //       imageName: files[i].name,
          //       pageTypeCode: pageTypeCodeName,
          //       specialLayout: true,
          //       specialLayoutWhitePagePosition: 'RIGHT'
          //     })
          //   }
          // } else {
          that.upLoadImgList.push({
            sorting: i,
            url: res,
            imageName: files[i].name,
            pageTypeCode: pageTypeCodeName,
            rotate: itemCheck.type === 2 ? (img.rotate + 90) : img.rotate
          })
          // }
          console.log('上传成功', that.upLoadImgList)
          i++
          if (i == files.length) {
            console.log('上传完成')
            that.loading.close()
            that.fileName = files[0].webkitRelativePath.split('/')[0]
            console.log('name', that.fileName)
          } else {
            that.imageAssemble(files, i, item)
          }
          // this.fileName = data.file.name
        })
      })
    },
    // 校验图片
    checkPageSize (index, files, width, height, xdpi, ydpi, pageType, color, spuDpi, rotate) {
      console.log('pageType', pageType, files, this.defaultSizeGroup)
      // let oneName = files[0].name
      let coverPages = files.filter(a => a.name.includes('封面'))
      let sizeList = this.defaultSizeGroup.sizeList.find(a => a.pageTypeCode == pageType)
      console.log('sizeList-封面-内页', sizeList)
      let sizeHeightError = 0.5
      let sizeWidthError = 0.5
      // 宽高增加出血尺寸
      let newWidth
      // 半P
      if (sizeList.spuPageName.templatePropertyCode === 'HALF_PAGE') {
        newWidth = sizeList.sizeWidth * 2 + sizeList.bleed.bleedLeft + sizeList.bleed.bleedRight
      } else {
        newWidth = sizeList.sizeWidth + sizeList.bleed.bleedLeft + sizeList.bleed.bleedRight
      }
      if (this.basicInfo.specialLayout && (index == coverPages.length || (index == (files.length - 1)))) {
        // 特殊排版校验宽度(首页是封面的时候，校验第二P,首页不是封面的时候，校验第一P,最后一P,是不是传的一半的尺寸)
        width = width * 2
      }
      // 宽高增加出血尺寸
      let newHeight = sizeList.sizeHeight + sizeList.bleed.bleedTop + sizeList.bleed.bleedBottom
      console.log('宽高-----', width, newWidth)
      console.log('高宽++++', height, newHeight)
      // 宽宽，高高相同    宽高，高宽相同
      let w = Math.abs(width - newWidth)
      if (this.basicInfo.specialLayout && (index == coverPages.length || (index == (files.length - 1)))) {
        // 特殊排版，由于宽度*了2，导致误差值翻倍，所以这里误差值要再/2
        w = w / 2
      }
      let h = Math.abs(height - newHeight)
      let wh = Math.abs(width - newHeight)
      let hw = Math.abs(height - newWidth)
      let w1 = sizeWidthError
      let h1 = sizeHeightError
      let error = ''
      let type = 0
      let sizeError = (pageType == 'COVER' ? '封面' : pageType == 'SINGLE' ? '单页' : '内页') + '尺寸错误'
      if (!(color === '3' || color === 'RGB' || color === 'RGB with Alpha')) {
        error = '色彩模式应为RGB'
      } else if ((spuDpi === 300 && (+xdpi > 301 || +ydpi > 301)) || (spuDpi === 254 && (+xdpi < 253 || +ydpi < 253))) {
        error = '分辨率错误'
      } else if (newWidth == newHeight) {
        // 新加的：宽高尺寸相同的时候，只要一边大于误差值尺寸就不对
        if (w > w1 || h > h1) {
          error = sizeError
        }
      } else {
        // 旋转角度是90或者270 旋转之后的宽高匹配 (这里倒过来匹配是因为：旋转之后的宽高，获取到的是之前的)
        if (rotate == 90 || rotate == 270) {
          console.log('有角度', rotate)
          if (wh > w1 || hw > h1) {
            // 相框，摆台判断颠倒过来之后的宽高误差值，如果也匹配不上，尺寸错误
            if (this.$route.query.spuType == 'PHOTO_FRAME' || this.$route.query.spuType == 'STAGE') {
              if (w > w1 || h > h1) {
                error = sizeError
              } else {
                error = ''
                type = 2
              }
            } else {
              error = sizeError
            }
          } else {
            error = ''
          }
        } else {
          console.log('没有角度', rotate)
          console.log('w:', w, 'h:', h, 'wh:', wh, 'hw:', hw, 'w1:', w1, 'h1:', h1)
          // 只要宽高有一边匹配不上，相框，摆台再判断宽高颠倒之后的
          if (w > w1 || h > h1) {
            // 相框，摆台判断颠倒过来之后的宽高误差值，如果也匹配不上，尺寸错误
            if (this.$route.query.spuType == 'PHOTO_FRAME' || this.$route.query.spuType == 'STAGE') {
              if (wh > w1 || hw > h1) {
                error = sizeError
              } else {
                error = ''
                type = 2
              }
            } else {
              error = sizeError
            }
          } else {
            error = ''
          }
        }
      }
      return {
        error,
        type
      }
    },
    // 确定上传
    async addThemeFile () {
      if (!this.sampleThemeForm.skuId) {
        this.$message.error('请选择sku')
        return
      }
      if (this.upLoadImgList.length == 0) {
        this.$message.error('请上传文件')
        return
      }
      let pageTypeVOS1 = this.upLoadImgList.filter(a => a.pageTypeCode == 'COVER') // 封面
      let pageTypeVOS2 = this.upLoadImgList.filter(a => {
        if (a.pageTypeCode == 'TEXT' || a.pageTypeCode == 'SINGLE') {
          return a
        }
      })
      let pageTypeVOS = []
      // 判断是否有封面
      if (pageTypeVOS1.length > 0) {
        pageTypeVOS = [
          {
            imageUrlVOS: pageTypeVOS1.map(a => {
              return {
                sorting: a.sorting,
                url: a.url,
                name: a.imageName,
                rotate: a.rotate
              }
            }),
            pageTypeCode: pageTypeVOS1[0].pageTypeCode
          },
          {
            imageUrlVOS: pageTypeVOS2.map((a, i) => {
              if (this.basicInfo.specialLayout && i == 0) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName,
                  specialLayout: true,
                  specialLayoutWhitePagePosition: 'LEFT',
                  rotate: a.rotate
                }
              } else if (this.basicInfo.specialLayout && i == (pageTypeVOS2.length - 1)) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName,
                  specialLayout: true,
                  specialLayoutWhitePagePosition: 'RIGHT',
                  rotate: a.rotate
                }
              } else {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName,
                  rotate: a.rotate
                }
              }
            }),
            pageTypeCode: pageTypeVOS2[0].pageTypeCode
          }
        ]
      } else {
        pageTypeVOS = [{
          imageUrlVOS: pageTypeVOS2.map((a, i) => {
            if (this.basicInfo.specialLayout && i == 0) {
              return {
                sorting: a.sorting,
                url: a.url,
                name: a.imageName,
                specialLayout: true,
                specialLayoutWhitePagePosition: 'LEFT',
                rotate: a.rotate
              }
            } else if (this.basicInfo.specialLayout && i == (pageTypeVOS2.length - 1)) {
              return {
                sorting: a.sorting,
                url: a.url,
                name: a.imageName,
                specialLayout: true,
                specialLayoutWhitePagePosition: 'RIGHT',
                rotate: a.rotate
              }
            } else {
              return {
                sorting: a.sorting,
                url: a.url,
                name: a.imageName,
                rotate: a.rotate
              }
            }
          }),
          pageTypeCode: pageTypeVOS2[0].pageTypeCode
        }]
      }
      console.log('pageTypeVOS', pageTypeVOS)
      let params = {
        sampleSkuImageVOS: [
          {
            pageTypeVOS: pageTypeVOS,
            skuId: this.sampleThemeForm.skuId
          }
        ],
        skuGroupId: this.$route.query.id,
        themeId: this.sampleThemeId
      }

      let res = await saveSampleImage(params)
      console.log('res', res)
      if (res.data.success) {
        this.$message.success('上传成功')
        this.closeSampleTheme()
        this.basicInfo.sampleThemeList = this.basicInfo.sampleThemeList.map(a => {
          if (a.id == this.sampleThemeId) {
            return {
              ...a,
              isUploaded: true
            }
          } else {
            return a
          }
        })
        console.log('this.basicInfo.sampleThemeList', this.basicInfo.sampleThemeList)
      }
    },
    closeSampleTheme () {
      this.upLoadSampleTheme = false
      this.sampleThemeForm = {}
      this.upLoadImgList = []
      this.fileName = ''
    },
    // 选择sku
    skuIdChange () {
      this.selectSkuListItem = this.selectSkuList.find(a => a.id == this.sampleThemeForm.skuId)
      console.log('selectSkuListItem', this.selectSkuListItem)
      console.log('this.sizeGroupList', this.sizeGroupList)
      composeGroupDetail(this.selectSkuListItem.composeSizeGroupId).then(res2 => {
        let obj = res2.data.data
        obj.detail = res2.data.data
        this.defaultSizeGroup = obj
        console.log('defaultSizeGroup', this.defaultSizeGroup)
      })
    },
    // 获取尺寸组类
    getSizeGroupTypeList () {
      groupCategoryList().then(res => {
        if (res.data.success) {
          this.sizeGroupTypeList = res.data.data
        }
      })
    },
    // 上传主图
    fileSize (data, row) {
      let id = row.id
      let xrefId = row.xrefId
      let file = data.target.files[0]
      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = function () {
          var width = image.width
          var height = image.height
          if (width === height) {
            _this.upload(file, id, xrefId)
          } else {
            _this.$message.error('图片长宽不相同')
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    // 上传图片
    upload (file, id, xrefId) {
      console.log('fileType', file.type)
      if (['image/png', 'image/jpg', 'image/jpeg', 'image/webp'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的图片格式')
        return
      }
      if (file.size > 1024 * 1024 * 1) {
        this.$message.error('图片大小不能超过1M')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(async res => {
        if (xrefId) {
          await updateSkuMainImage({
            skuMainImage: res,
            xrefId: xrefId
          })
        }
        let skuList = this.templateGroupList.map(element => {
          if (element.id === id) {
            return {
              ...element,
              skuMainImage: res
            }
          } else {
            return element
          }
        })
        this.templateGroupList = skuList
        console.log('this.templateGroupMsg.skuList', this.templateGroupList)
        // this.$forceUpdate()
      })
    },
    // 上传细节图（支持多图）
    fileSizeDetail (data, row) {
      let files = Array.from(data.target.files)
      let _this = this

      let promises = files.map((file) => {
        return new Promise((resolve) => {
          if (['image/png', 'image/jpg', 'image/jpeg', 'image/webp'].indexOf(file.type) === -1) {
            _this.$message.warning(`${file.name} 格式不正确`)
            resolve(null)
            return
          }
          if (file.size > 1024 * 1024 * 1) {
            _this.$message.error(`${file.name} 大小不能超过1M`)
            resolve(null)
            return
          }
          var reader = new FileReader()
          reader.onload = function (e) {
            var result = e.target.result
            var image = new Image()
            image.onload = function () {
              if (image.width !== image.height) {
                _this.$message.error(`${file.name} 长宽不相同`)
                resolve(null)
              } else {
                resolve(file)
              }
            }
            image.src = result
          }
          reader.readAsDataURL(file)
        })
      })

      Promise.all(promises).then(results => {
        let validFiles = results.filter(f => f !== null)
        if (validFiles.length > 0) {
          _this.uploadDetailBatch(validFiles, row)
        }
      })
    },
    // 批量上传细节图到服务器
    uploadDetailBatch (files, row) {
      let uploadPromises = files.map(file => {
        return uploadWebImg(file, this.$store.state.awsSdk.product.s3)
      })

      Promise.all(uploadPromises).then(async results => {
        if (row.xrefId) {
          await updateByGroupSkuXrefId({
            imageUrls: results,
            groupSkuXrefId: row.xrefId
          })
        }
        let skuList = this.templateGroupList.map(element => {
          if (element.id === row.id) {
            let existingImages = element.templateImageList || []
            return {
              ...element,
              templateImageList: [...existingImages, ...results]
            }
          } else {
            return element
          }
        })
        this.templateGroupList = skuList
        console.log('this.templateGroupList', this.templateGroupList)
      })
    },
    // 删除单张细节图
    removeDetailImage (row, index) {
      row.templateImageList.splice(index, 1)
    },
    // 触发PDF文件选择
    triggerPdfUpload (event) {
      const input = event.target.previousElementSibling
      if (input && input.type === 'file') {
        input.click()
      }
    },
    // 上传扉页通用烫金PDF文件
    uploadPdfFile (data, row) {
      const file = data.target.files[0]
      if (!file) return

      if (file.type !== 'application/pdf') {
        this.$message.warning('请上传PDF格式的文件')
        return
      }

      const maxSize = 70 * 1024 * 1024 // 10MB
      if (file.size > maxSize) {
        this.$message.error('PDF文件大小不能超过70M')
        return
      }
      let loading = this.$loading({
        lock: true,
        text: '正在上传文件，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(async res => {
        if (res === 'error') {
          this.$message.error('PDF上传失败')
          return
        }
        if (row.xrefId) {
          await updateSkuPdfUrl({
            pdfUrl: res,
            xrefId: row.xrefId
          })
        }
        // 更新行数据
        let skuList = this.templateGroupList.map(element => {
          if (element.id === row.id) {
            return {
              ...element,
              pdfUrl: res
            }
          } else {
            return element
          }
        })
        this.templateGroupList = skuList
        this.$message.success('PDF上传成功')
        loading.close()
      })
    },
    selectChange (value) {
      console.log('value', value)
      console.log('this.skuMsg', this.skuMsg)
    },
    templateDialogClosed () {
      this.searchGroupVo = {
        auditStatus: '',
        composeSizeGroupId: '',
        createTimeBegin: '',
        createTimeEnd: '',
        groupBelong: '',
        groupName: '',
        isAssociatedeSizeGroup: '',
        page: 1,
        propertyId: '',
        skuId: '',
        templateThemeId: ''
      }
      this.value = []
    },
    setDownloadTemplateGroup (val) {
      console.log(val)
      let data = {
        isDownload: !val.skuDefaultDownload ? 0 : 1,
        skuId: this.searchGroupVo.skuId,
        templateGroupId: val.id
      }
      setDownloadTemplateGroup(data)
        .then(res => {
          if (res.data.success) {
            this.$message.success('设置完成')
            this.getTemplateThemeList()
          }
        })
    },
    setDefaultTemplateGroup (val) {
      console.log(val)
      let data = {
        act: val.defaultTemplateGroupId === val.id ? 0 : 1,
        skuId: this.searchGroupVo.skuId,
        defaultTemplateGroupId: val.id
      }
      setDefaultTemplateGroup(data)
        .then(res => {
          if (res.data.success) {
            this.$message.success('设置完成')
            this.getTemplateThemeList()
          }
        })
    },
    deleteSP (row) {
      skuSpecialPriceDeleteBySpecialId(row.id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getSkuGroupMsg()
        }
      })
    },
    asd () {
    },
    closed () {
      this.activeName = 'a0'
      this.addSkuStep = 1
      this.skuMsgName = ''
      this.pageNameTableData = []
      console.log(this.skuMsg)
      console.log(this.skuMsg.isHavePromoCode)
      // this.$refs.formaaa.resetFields()
    },
    // 取消关联
    cancelCorrelation (row) {
      let groupSkuXrefVo = {
        groupIds: [row.id],
        skuId: this.addCorrelationSkuId,
        state: 0
      }
      groupSkuRelateGroup([groupSkuXrefVo]).then(res => {
        if (res.data.success) {
          this.$message.success('取消关联成功')
          this.searchGroupVo.skuId = this.addCorrelationSkuId
          this.sizeGroupQueryInfo.pageNum = 1
          this.getTemplateThemeList()
        }
      })
    },
    // 关联模板组
    Correlation (row) {
      // if (this.selectTemplateList.length === 0) {
      //   this.$message.error('未选择模板组')
      //   return
      // }
      if (!row.skuMainImage) {
        this.$message.warning('请上传模板主图')
        return
      }
      if (this.isTitlePageSku && !row.pdfUrl) {
        this.$message.warning('请上传扉页通用烫金文件')
        return
      }
      // 内页P数
      console.log(this.maxPage, 'this.maxPage')
      let templateGroupNum = ''
      let singleNum = ''
      let coverNum = '' // 新增----封面
      row.templateGroupList.forEach(item => {
        if (item.typeName === '内页') {
          templateGroupNum = this.textIsBase ? item.templateGroupNum : 0
        }
        if (item.typeName === '单页') {
          singleNum = this.singleIsBase ? item.templateGroupNum : 0
        }
        if (item.typeName === '封面') {
          coverNum = this.coverIsBase ? item.templateGroupNum : 0
        }
      })
      if (this.addCorrelationType === 'single') {
        console.log(row, 'row')
        // let sum = templateGroupNum + singleNum
        let sum = templateGroupNum + singleNum + coverNum
        if (sum) {
          if (sum < this.maxPage) {
            this.tipDialog = true
          } else {
            let groupSkuXrefVo = {
              groupIds: [],
              skuId: this.addCorrelationSkuId,
              state: 1,
              skuMainImage: row.skuMainImage,
              pdfUrl: row.pdfUrl,
              templateImageList: row.templateImageList || []
            }
            groupSkuXrefVo.groupIds = [row.id]
            groupSkuRelateGroup([groupSkuXrefVo]).then(res => {
              if (res.data.success) {
                this.$message.success('关联成功')
                this.searchGroupVo.skuId = this.addCorrelationSkuId
                this.sizeGroupQueryInfo.pageNum = 1
                this.addCorrelation = false
                this.getTemplateThemeList()
              }
            })
          }
        } else {
          this.tipDialog = true
        }
      } else if (this.addCorrelationType === 'all') {
        let templateVOList = []
        let groupIds = [row.id]
        this.basicInfo.skuList.forEach(sku => {
          templateVOList.push({
            groupIds,
            skuId: sku.id,
            state: 1,
            skuMainImage: row.skuMainImage,
            pdfUrl: row.pdfUrl,
            templateImageList: row.templateImageList || []
          })
        })
        groupSkuRelateGroup(templateVOList).then(res => {
          if (res.data.success) {
            this.$message.success('关联成功')
            this.addCorrelation = false
            this.templateDialog = false
          }
        })
      }
    },
    // 删除Sku
    deleteSku () {
      skuDelete(this.deleteSkuMsg.row.id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.basicInfo.skuList.splice(this.deleteSkuMsg.$index, 1)
          this.deleteSkuDialog = false
        }
      })
    },
    // 确认添加sku
    confirmAddSku () {
      if (this.isEditSku === 'check') {
        this.addSkuStep = 1
        this.activeName = 'a0'
        this.addSkuDialog = false
      } else if (this.isEditSku) {
        if (this.addLock) {
          this.$message.error('请稍后')
          return
        }
        this.skuMsg.skuId = this.skuMsg.id
        this.skuMsg.salePrice = this.skuMsg.terminalSalePrice
        this.addLock = true
        // 新增，将skuPageType换成最新的
        this.skuMsg.skuPageSettingList = this.skuMsg.skuPageSettingList.map((a, i) => {
          this.pageNameTableData.forEach((b, x) => {
            if (i === x) {
              a.skuPageType = b.pageTypeCode
            }
          })
          return a
        })
        console.log('this.skuMsg', this.skuMsg)
        // 积分商城产品不能编辑在线支付价格，默认读取基础P
        if (this.$route.query.showPoint == 'true') {
          this.skuMsg.onlineSalePrice = this.skuMsg.basePagePrice
          this.skuMsg.onlineBaseStepPrice = this.skuMsg.baseStepPrice
        }
        skuUpdate({ editSkuVo: this.skuMsg, skuId: this.skuMsg.id }).then(res => {
          if (res.data.success) {
            this.$message.success('修改成功')
            this.getSkuGroupMsg()
            this.addSkuDialog = false
            this.addSkuStep = 1
            this.activeName = 'a0'
          }
          this.addLock = false
        })
      } else {
        // this.skuMsg.skuName = this.skuMsg.skuName ? this.skuMsg.skuName : (this.basicInfo.skuGroupName + this.skuMsg.basePage + '-' + this.skuMsg.maxPage)
        this.skuMsg.skuGroupId = this.$route.query.id
        this.skuMsg.spuId = this.basicInfo.spuId
        this.skuMsg.salePrice = this.skuMsg.terminalSalePrice
        if (this.addLock) {
          this.$message.error('请稍后')
          return
        }
        this.addLock = true
        skuAdd(this.skuMsg).then(res => {
          if (res.data.success) {
            this.getSkuGroupMsg()
            this.$message.success('添加成功')
            this.addSkuDialog = false
            this.addSkuStep = 1
          }
          this.addLock = false
        })
      }
    },
    // 获取条码位置
    getBarPositionList () {
      barCodePosition().then(res => {
        if (res.data.success) {
          this.barPosition.page.has = res.data.data
          this.barPosition.page.none = res.data.data.filter(item => {
            return item.dictValue.indexOf('白页') === -1
          })
          this.barPosition.cover.has = res.data.data.filter(item => {
            return item.dictValue.indexOf('步长') === -1
          })
          this.barPosition.cover.none = this.barPosition.cover.has.filter(item => {
            return item.dictValue.indexOf('白页') === -1
          })
        }
      })
    },
    // 计算基础p
    countP (val) {
      let num = 0
      this.pageNameTableData.forEach(item => {
        num += item.isBase ? +item.pageNum : 0
        // let type = item.pageTypeCode.toLowerCase()
        if (/[^\d]/g.test(item.pageNum) || item.pageNum <= 0) {
          this.pageNumLock = true
        } else {
          this.pageNumLock = false
        }
        this.skuMsg[item.pageTypeCode.toLowerCase() + 'Page'] = item.pageNum
        if (this.pageNumLock) {
          this.$message.error('数量只能输入大于等于1的值')
        }
        // if (item.pageTypeCode === 'COVER') {
        //   this.skuMsg.coverPage = item.pageNum
        // } else if (item.pageTypeCode === 'SINGLE') {
        //   this.skuMsg.singlePage = item.pageNum
        // }
      })
      this.skuMsg.basePage = num
      this.$forceUpdate()
    },
    // 添加Sku 先判定该Sku组有无选择默认尺寸组
    addSku () {
      // this.isEditSku = false
      // this.addSkuDialog = true
      if (this.basicInfo.skuList.length > 0) {
        this.haveSkuList = true
      } else {
        this.haveSkuList = false
      }
      console.log('this.singlePrice', this.singlePrice)
      let b = false
      console.log(typeof this.skuMsg.isHavePromoCode)
      console.log(this.skuMsg)
      console.log(this.skuMsg.isHavePromoCode)
      let a = typeof this.skuMsg.isHavePromoCode
      if (a === 'boolean') {
        if (this.skuMsg.isHavePromoCode) {
          b = this.skuMsg.isHavePromoCode
          this.disable = true
        }
      } else {
        if (this.skuMsg.isHavePromoCode === 'true') {
          console.log(this.skuMsg.isHavePromoCode)
          b = true
          this.disable = true
        }
      }
      console.log('默认尺寸组', b)
      // if (this.defaultSizeGroup !== null) {
      console.log(11111111111111)
      this.isEditSku = false
      this.addSkuDialog = true
      // sku组已经选择了默认尺寸组
      this.skuMsg = {
        skuPrefix: '',
        basePage: 0,
        basePagePrice: this.singlePrice && this.haveSkuList ? this.basicInfo.skuList[0].basePagePrice : '',
        baseStep: 1,
        baseStepPrice: this.singlePrice ? 0 : b ? 0 : '',
        onlineSalePrice: this.singlePrice && this.haveSkuList ? this.basicInfo.skuList[0].onlineSalePrice : '',
        startupsBasePagePrice: this.singlePrice && this.haveSkuList ? this.basicInfo.skuList[0].startupsBasePagePrice : '',
        onlineBaseStepPrice: this.singlePrice ? 0 : b ? 0 : '',
        startupsBaseStepPrice: this.singlePrice ? 0 : b ? 0 : '', // 初创平台步长
        terminalSalePrice: this.singlePrice && this.haveSkuList ? this.basicInfo.skuList[0].terminalSalePrice : '',
        terminalStepSalePrice: this.singlePrice ? 0 : '',
        coverPage: 0,
        singlePage: 0,
        composeSizeGroupId: this.defaultSizeGroup ? this.defaultSizeGroup.id : null,
        maxPage: '',
        skuName: '',
        skuFrontName: '',
        isHavePromoCode: b,
        isComposeHalfP: false,
        isZeroPurchase: false,
        limitQuantity: true,
        specialPrint: 0,
        coverPosition: '',
        leftParam: '',
        topParam: ''
        // salePrice: ''
      }
      let list = []
      list = this.defaultSizeGroup ? JSON.parse(JSON.stringify(this.defaultSizeGroup.detail.sizeList)) : []
      // this.skuMsgName = this.defaultSizeGroup.groupName
      list.forEach(page => {
        page.isBase = page.spuPageName.isBase
        page.isEditable = page.spuPageName.isEditable
        page.pageNum = 1
      })
      this.skuMsg.skuPageSettingVOList = []
      list.forEach(item => {
        console.log('item.barCodeList', item.barCodeList)
        let obj = {
          barCodePositionList: [],
          noAllowEditPage: '',
          deletePage: '',
          noAllowSortPage: '',
          generalFilePage: '',
          titlePagePdfPage: '',
          pdfPage: '',
          readonlyPage: '',
          skuPageSettingHalfPageVOS: [
            {
              sort: null,
              noAllowEditPage: '',
              position: null
            }
          ],
          noComposePageNumEnd: '',
          noComposePageNumStart: '',
          skuPageType: item.pageTypeCode,
          splitPdf: 0,
          splitPageYk: '',
          splitPageYkDesc: '',
          splitPageTp: '',
          splitPageTpDesc: '',
          splitPageMstp: '',
          splitPageMstpDesc: '',
          splitPageTjuv: '',
          splitPageTjuvDesc: '',
          splitPageTljuv: '',
          splitPageTljuvDesc: '',
          splitPageTlsyuv: '',
          splitPageTlsyuvDesc: '',
          splitPageTlsjuv: '',
          splitPageTlsjuvDesc: '',
          splitPageMGIYuv: '',
          splitPageMGIYuvDesc: '',
          splitPageNpz: '',
          splitPageNpzDesc: '',
          splitPageQt: '',
          splitPageQtDesc: '',
          flip: 0,
          flipAllPage: 0,
          flipEvenPage: 0,
          flipOddPage: 0,
          flipSpecifyPage: ''
        }
        if (item.barCodeList.length > 0) {
          item.barCodeList.forEach(bar => {
            obj.barCodePositionList.push({
              barCodeId: bar.id,
              barCodePosition: ''
            })
          })
        } else {
          obj.barCodePositionList.push({
            barCodeId: '',
            barCodePosition: ''
          })
        }
        this.skuMsg.skuPageSettingVOList.push(obj)
        if (item.pageTypeCode === 'COVER') {
          if (this.basicInfo.whitePageId) {
            item.barPosition = this.barPosition.cover.has
          } else {
            item.barPosition = this.barPosition.cover.none
          }
        } else {
          if (this.basicInfo.whitePageId) {
            item.barPosition = this.barPosition.page.has
          } else {
            item.barPosition = this.barPosition.page.none
          }
        }
      })
      console.log('this.skuMsg.skuPageSettingVOList', this.skuMsg.skuPageSettingVOList)
      this.skuMsg = JSON.parse(JSON.stringify(this.skuMsg))
      console.log('this.skuMsg', this.skuMsg)
      // this.pageNameTableData = list
      this.countP(this.defaultSizeGroup)
      // } else {
      // this.$message.error('未绑定尺寸组，请先绑定')
      // this.hintDialog = true
      // 以下原本就注释了
      // this.skuMsg = {
      //   skuPrefix: '',
      //   basePage: '',
      //   basePagePrice: '',
      //   baseStep: 1,
      //   baseStepPrice: '',
      //   onlineSalePrice: '',
      //   onlineBaseStepPrice: '',
      //   terminalSalePrice: '',
      //   terminalStepSalePrice: '',
      //   // salePrice: '',
      //   coverPage: 0,
      //   singlePage: 0,
      //   composeSizeGroupId: '',
      //   maxPage: '',
      //   skuName: '',
      //   skuFrontName: '',
      //   skuPageSettingVOList: []
      // }
      // this.pageNameTableData = []
      // this.skuMsgName = ''
      // }
    },
    // 统一关联尺寸组
    relation (type, row) {
      if (type === 'all') {
        this.defaultSizeGroup = row
        this.$message.success('关联成功')
        this.sizeDialog = false
      } else if (type === 'sku') {
        if (this.defaultSizeGroup === null) {
          this.defaultSizeGroup = row
        }
        let list = []
        list = JSON.parse(JSON.stringify(row.detail.sizeList))
        this.skuMsgName = row.groupName
        this.skuMsg.composeSizeGroupId = row.id
        this.skuMsg.coverPage = 0
        list.forEach(page => {
          page.isBase = page.spuPageName.isBase
          page.isEditable = page.spuPageName.isEditable
          page.pageNum = 1
          if (page.pageTypeCode == 'COVER') {
            this.skuMsg.coverPage++
          }
        })
        this.skuMsg.skuPageSettingVOList = []
        list.forEach(item => {
          let obj = {
            barCodePositionList: [],
            noAllowEditPage: '',
            deletePage: '',
            noAllowSortPage: '',
            generalFilePage: '',
            titlePagePdfPage: '',
            pdfPage: '',
            readonlyPage: '',
            skuPageSettingHalfPageVOS: [
              {
                sort: null,
                noAllowEditPage: '',
                position: null
              }
            ],
            noComposePageNumEnd: '',
            noComposePageNumStart: '',
            skuPageType: item.pageTypeCode,
            splitPdf: 0,
            splitPageYk: '',
            splitPageYkDesc: '',
            splitPageTp: '',
            splitPageTpDesc: '',
            splitPageMstp: '',
            splitPageMstpDesc: '',
            splitPageTjuv: '',
            splitPageTjuvDesc: '',
            splitPageTljuv: '',
            splitPageTljuvDesc: '',
            splitPageTlsyuv: '',
            splitPageTlsyuvDesc: '',
            splitPageTlsjuv: '',
            splitPageTlsjuvDesc: '',
            splitPageMGIYuv: '',
            splitPageMGIYuvDesc: '',
            splitPageNpz: '',
            splitPageNpzDesc: '',
            splitPageQt: '',
            splitPageQtDesc: '',
            flip: 0,
            flipAllPage: 0,
            flipEvenPage: 0,
            flipOddPage: 0,
            flipSpecifyPage: ''
          }
          if (item.barCodeList.length > 0) {
            item.barCodeList.forEach(bar => {
              obj.barCodePositionList.push({
                barCodeId: bar.id,
                barCodePosition: ''
              })
            })
          } else {
            obj.barCodePositionList.push({
              barCodeId: '',
              barCodePosition: ''
            })
          }
          this.skuMsg.skuPageSettingVOList.push(obj)
          if (item.spuPageName.pageTypeCode === 'COVER') {
            if (this.basicInfo.whitePageId) {
              item.barPosition = this.barPosition.cover.has
            } else {
              item.barPosition = this.barPosition.cover.none
            }
          } else {
            if (this.basicInfo.whitePageId) {
              item.barPosition = this.barPosition.page.has
            } else {
              item.barPosition = this.barPosition.page.none
            }
          }
        })
        this.skuMsg = JSON.parse(JSON.stringify(this.skuMsg))
        this.pageNameTableData = list
        this.$message.success('关联成功')
        this.countP(this.defaultSizeGroup)
        this.sizeDialog = false
      }
    },
    // 获取尺寸组信息
    getSizeGroupList () {
      groupListPageing({ pageNum: this.sizeGroupQueryInfo.pageNum, pageSize: this.sizeGroupQueryInfo.pageSize, data: this.searchComposeSizeGroupVO }).then(res => {
        this.sizeGroupQueryInfo.total = res.data.data.total
        if (res.data.success) {
          if (res.data.data.records.length === 0) {
            this.sizeGroupList = res.data.data.records
          }
          let list = res.data.data.records
          let num = 0
          // this.tableData = res.data.data.records
          res.data.data.records.forEach(item => {
            composeGroupDetail(item.id).then(res2 => {
              item.detail = res2.data.data
              num++
              if (num >= list.length) {
                this.sizeGroupList = list
              }
            })
          })
        }
      })
    },
    // 获取模板组详情
    getTemplateGroupMsg (id) {
      groupQueryGroupById(id).then(res => {
        if (res.data.success) {
          // this.tem
          let arr = []
          res.data.data.templateList.forEach(page => {
            // page.templates.forEach(item => {
            //   arr.push(item)
            // })
            page.groupVos.forEach(item => {
              item.templates.forEach(temp => {
                arr.push({ ...temp, pageTypeCode: item.pageTypeCode })
              })
            })
          })
          this.templateList = arr
        }
      })
    },
    //
    // 获取模板组列表
    getTemplateThemeList () {
      console.log('模板列表', this.addCorrelation)
      if (this.addCorrelation) { // 添加关联
        console.log(this.searchGroupVo, 'this.searchGroupVo')
        this.searchGroupVo.auditStatus = 'AUDITED'
        // this.searchGroupVo.composeSizeGroupId = this.defaultSizeGroup.id
        this.searchGroupVo.skuId = this.addCorrelationSkuId
        getGroupListForSkuRelate({ pageSize: this.tempQueryInfo.pageSize, pageNum: this.tempQueryInfo.pageNum, searchGroupVo: this.searchGroupVo }).then(res => {
          if (res.data.success) {
            this.templateGroupList = res.data.data.records
            // 回显细节模板主图
            this.templateGroupList.forEach(item => {
              if (item.templateImageList && item.templateImageList.length > 0) {
                item.templateImageList = item.templateImageList.map(a => {
                  return a.imageUrl
                })
              }
            })
            this.tempQueryInfo.total = res.data.data.total
          }
        })
      } else {
        this.searchGroupVo.auditStatus = ''
        getGroupListBySkuId({ pageSize: this.tempQueryInfo.pageSize, pageNum: this.tempQueryInfo.pageNum, data: this.searchGroupVo }).then(res => {
          if (res.data.success) {
            let list = res.data.data.records
            list.forEach(item => {
              console.log(item.defaultTemplateGroupId === item.id)
              item.defaultUse = item.defaultTemplateGroupId === item.id
            })
            this.templateGroupList = list.map(a => {
              a.templateImageList = a.templateImageList?.map(b => {
                return b.imageUrl
              })
              return a
            })
            this.tempQueryInfo.total = res.data.data.total
          }
        })
      }
    },
    // 管理模板组
    async tempAdmin (scope) {
      console.log(scope, 'scope')
      this.isTitlePageSku = scope.row.specialPrint && scope.row.skuPageSettingList.find(a => a.skuPageType == 'TEXT' && a.titlePagePdfPage)
      this.maxPage = this.basicInfo.isPdf ? this.basicInfo.pdfTemplateNums : scope.row.maxPage
      // 获取该sku的尺寸组详情
      await composeGroupDetail(scope.row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          let list = []
          res.data.data.sizeList.forEach(size => {
            list.push(...size.spuPageName.templateProperty.split(','))
            // 新增-----内页，封面，单页是否计入基础P数判断条件
            if (size.spuPageName.pageTypeCode === 'TEXT') { // 内页
              this.textIsBase = size.spuPageName.isBase
            } else if (size.spuPageName.pageTypeCode === 'COVER') { // 封面
              this.coverIsBase = size.spuPageName.isBase
            } else if (size.spuPageName.pageTypeCode === 'SINGLE') { // 单页
              this.singleIsBase = size.spuPageName.isBase
            }
          })
          list = Array.from(new Set(list))
          this.propertyList = this.allPropertyList.filter(item => {
            return list.indexOf(item.propertyName) !== -1
          })
          this.addCorrelation = false
          this.addCorrelationType = 'single'
          this.addCorrelationSkuId = scope.row.id
          this.sizeGroupQueryInfo.pageNum = 1
          this.searchGroupVo.skuId = scope.row.id
          this.searchGroupVo.composeSizeGroupId = scope.row.composeSizeGroupId
          this.getTemplateThemeList()
          this.templateDialog = true
        }
      })
    },
    // 获取模板性质列表
    getFormatList () {
      propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.allPropertyList = res.data.data
        }
      })
    },
    fileChange (e) {
      let file = e.target.files[0]
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/webp') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = function () {
          var width = image.width
          var height = image.height
          if (_this.$route.query.categoryId == 10 || _this.$route.query.categoryId == 13) {
            if (width == 960 && height == 1080) {
              uploadWebImg(file, _this.$store.state.awsSdk.product.s3).then(res => {
                _this.basicInfo.skuGroupImage = res
              })
            } else {
              _this.$message.error('图片长宽应为960*1080')
            }
          } else {
            if (width === height) {
              uploadWebImg(file, _this.$store.state.awsSdk.product.s3).then(res => {
                _this.basicInfo.skuGroupImage = res
              })
            } else {
              _this.$message.error('图片长宽不相同')
            }
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    updateImg () {
      document.getElementById('upload_file').click()
    },
    // 选择样品主题
    onSelectSample () {
      // this.basicInfo.sampleThemeList = []
    },
    // 删除样品主题
    deleteTheme (id, index) {
      skuSampleDelete({ skuGroupId: this.$route.query.id, themeId: id }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.basicInfo.sampleThemeList.splice(index, 1)
        }
      })
    },
    sampleThemeAdd () {
      if (this.selectSample === '') {
        this.$message.error('请选择样品主题')
        return
      }
      this.addSampleTheme = true
    },
    // 添加样品主题
    addTheme () {
      if (this.selectSample === '') {
        this.$message.error('请选择样品主题')
        return
      }
      let lock = false
      this.basicInfo.sampleThemeList.forEach(item => {
        if (item.id === this.selectSample.id) {
          lock = true
        }
      })
      if (lock) {
        this.$message.error('该主题已存在')
      } else {
        skuSampleSave({ skuGroupId: this.$route.query.id, themeId: this.selectSample.id }).then(res => {
          if (res.data.success) {
            this.$message.success('添加成功')
            this.basicInfo.sampleThemeList.push({ ...this.selectSample, skuGroupSampleImageList: [] })
            this.addSampleTheme = false
          }
        })
      }
    },
    // 上传样品文件
    upLoadTheme (id) {
      this.sampleThemeId = id
      this.upLoadSampleTheme = true
    },
    // 预览样品图片
    async previewImg (id) {
      let val = {
        skuGroupId: this.$route.query.id,
        id: id
      }
      let res = await previewSampleImage(val)
      console.log('res', res)
      if (res.data.success && res.data.data.length > 0) {
        this.imageList = []
        res.data.data.forEach(a => {
          a.pageTypeVOS.forEach(b => {
            // console.log('b.imageInfos', b.imageInfos)
            this.imageList = this.imageList.concat(b.imageInfos)
          })
        })
        console.log('this.imageList ', this.imageList)
        this.itemImgs.name = this.imageList[0].imageName
        this.itemImgs.index = 1
        // res.data.data[0].pageTypeVOS[0].imageInfos
        this.imgViewerVisible = true
      }
    },
    // 轮播图切换
    carouselChange (i) {
      console.log('val', i)
      this.itemImgs.name = this.imageList[i].imageName
      this.itemImgs.index = i + 1
    },
    /* 预览轮播切换 */
    onClickCarousel (type) {
      if (type === 'prev') this.$refs['el-carousel'].prev()
      if (type === 'next') this.$refs['el-carousel'].next()
    },
    changeSamplePrice () {
      if (this.editPriceDialog) {
        if (!this.$reg.price.reg.test(this.basicInfo.samplePrice)) {
          this.$message.error('样品价格' + this.$reg.price.message)
          return
        }
      }
      this.editPriceDialog = !this.editPriceDialog
    },
    changeOnlineSamplePrice () {
      if (this.onlineSamplePriceDialog) {
        if (!this.$reg.price.reg.test(this.basicInfo.onlineSamplePrice)) {
          this.$message.error('在线支付样品价格' + this.$reg.price.message)
          return
        }
      }
      this.onlineSamplePriceDialog = !this.onlineSamplePriceDialog
    },
    changeStartupsSamplePrice () {
      if (this.startupsSamplePriceDialog) {
        if (!this.$reg.price.reg.test(this.basicInfo.startupsSamplePrice)) {
          this.$message.error('初创平台样品价格' + this.$reg.price.message)
          return
        }
      }
      this.startupsSamplePriceDialog = !this.startupsSamplePriceDialog
    },

    changeSamplePointPrice () {
      if (this.editePointsDialog) {
        if (!this.$reg.checkInteger.reg.test(this.basicInfo.samplePoints)) {
          this.$message.error('样品积分价格' + this.$reg.checkInteger.message)
          return
        }
      }
      this.editePointsDialog = !this.editePointsDialog
    },
    // 保存修改
    save () {
      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.$route.query.spuProperty === 'NORMAL') {
          let simpleCurrencySkuGroupVO = {
            dictIdSet: '',
            dictSet: '',
            price: this.basicInfo.skuList[0].basePagePrice,
            basePagePoints: this.basicInfo.skuList[0].basePagePoints,
            salePrice: this.basicInfo.skuList[0].salePrice,
            sampleBarCode: this.basicInfo.skuList[0].sampleBarCode,
            onlineSalePrice: this.basicInfo.skuList[0].onlineSalePrice,
            startupsBasePagePrice: this.basicInfo.skuList[0].startupsBasePagePrice,
            skuGroupImage: this.basicInfo.skuGroupImage,
            skuGroupName: this.basicInfo.skuGroupName,
            skuName: this.basicInfo.skuGroupName,
            stockCount: this.basicInfo.stockCount,
            isTimeLimit: this.basicInfo.isTimeLimit,
            timeLimitEndTime: this.basicInfo.isTimeLimit && this.limitTime ? this.limitTime[1] : '',
            timeLimitStartTime: this.basicInfo.isTimeLimit && this.limitTime ? this.limitTime[0] : '',
            terminalSalePrice: this.basicInfo.skuList[0].salePrice,
            terminalStepSalePrice: 0
          }
          this.dictList.forEach(key => {
            simpleCurrencySkuGroupVO.dictIdSet += key.id + ':' + key.value.id + ';'
            simpleCurrencySkuGroupVO.dictSet += key.key + ':' + key.value.propVal + ';'
          })
          skuGroupUpdateCurrency({ skuGroupId: this.$route.query.id, simpleCurrencySkuGroupVO }).then(res => {
            if (res.data.success) {
              this.$message.success('修改成功')
              this.$router.go(-1)
            }
          })
        } else {
          if (!this.$reg.price.reg.test(this.basicInfo.samplePrice)) {
            this.$message.error('样品价格' + this.$reg.price.message)
            return
          }
          if (!this.$reg.price.reg.test(this.basicInfo.onlineSamplePrice)) {
            this.$message.error('样品价格' + this.$reg.price.message)
            return
          }
          if (this.basicInfo.isTimeLimit && !this.limitTime[0]) {
            this.$message.error('请选择有效期')
            return
          }
          let editSkuGroupVo = {
            samplePrice: this.basicInfo.samplePrice,
            onlineSamplePrice: this.basicInfo.onlineSamplePrice,
            startupsSamplePrice: this.basicInfo.startupsSamplePrice,
            skuGroupImage: this.basicInfo.skuGroupImage,
            skuGroupName: this.basicInfo.skuGroupName,
            stockCount: this.basicInfo.stockCount,
            isTimeLimit: this.basicInfo.isTimeLimit,
            timeLimitEndTime: this.basicInfo.isTimeLimit && this.limitTime ? this.limitTime[1] : '',
            timeLimitStartTime: this.basicInfo.isTimeLimit && this.limitTime ? this.limitTime[0] : ''
          }
          if (this.basicInfo.samplePoints) {
            editSkuGroupVo.samplePoints = this.basicInfo.samplePoints
          }
          skuGroupUpdate({ skuGroupId: this.$route.query.id, editSkuGroupVo }).then(res => {
            if (res.data.success) {
              this.$message.success('修改成功')
              this.$router.go(-1)
            }
          })
        }
      })
    },
    // 添加sku下一步
    addSkuNextStep () {
      console.log('下一步', this.pageNameTableData)
      this.$refs.formaaa.validate((valid) => {
        if (valid) {
          if (this.skuMsg.isComposeHalfP > this.skuMsg.basePage) {
            this.$message.error('用户应上传照片张数应小于或等于基础P数量')
            return
          }
          let hasPage = this.pageNameTableData.some(page => {
            return page.pageTypeCode === 'TEXT'
          })
          if (!hasPage && this.skuMsg.basePage !== this.skuMsg.maxPage) {
            this.$message.error('尺寸组没有内页，基础P应等于最大P')
          } else if (this.pageNumLock) {
            this.$message.error('页面数量只能输入大于等于1的值')
          } else if ((this.skuMsg.maxPage - this.skuMsg.basePage) % this.skuMsg.baseStep !== 0) {
            this.$message.error('最大P数和步长不匹配')
          } else if (this.skuMsg.maxPage < this.skuMsg.basePage) {
            this.$message.error('最大P数不得小于基础P')
          } else {
            if (this.isEditSku === 'check') {
              this.addSkuStep = 2
              return
            }
            console.log('下一步', this.skuMsg)
            skuUsable({ skuName: this.skuMsg.skuName, isUpdate: !!this.isEditSku, isFront: false, skuId: this.skuMsg.id }).then(res => {
              if (res.data.success) {
                skuUsable({ skuName: this.skuMsg.skuFrontName, isUpdate: !!this.isEditSku, isFront: true, skuId: this.skuMsg.id }).then(res => {
                  if (res.data.success) {
                    this.addSkuStep = 2
                  }
                })
              }
            })
          }
        }
      })
    },
    SampleList () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.sampleList = res.data.data
        }
      })
    },
    // 编辑sku
    editSku (row, value) {
      let specialPrint = row.specialPrint === true ? 1 : row.specialPrint === false ? 0 : null
      let b = false
      console.log(typeof this.skuMsg.isHavePromoCode)
      console.log(this.skuMsg)
      console.log(this.skuMsg.isHavePromoCode)
      let a = typeof this.skuMsg.isHavePromoCode
      if (a === 'boolean') {
        if (this.skuMsg.isHavePromoCode) {
          b = this.skuMsg.isHavePromoCode
          this.disable = true
        }
      } else {
        if (this.skuMsg.isHavePromoCode === 'true') {
          console.log(this.skuMsg.isHavePromoCode)
          b = true
          this.disable = true
        }
      }
      console.log(b)
      console.log('传进来的', row)
      // 上架状态
      if (this.$route.query.onSale === 'true') {
        // 编辑
        if (value === 1) {
          this.isdisabled = true
          this.isEditSku = true
        } else {
          this.isdisabled = false
          this.isEditSku = 'check'
        }
      }
      composeGroupDetail(row.composeSizeGroupId).then(res => {
        console.log('res获取详情-编辑', res)
        if (res.data.success) {
          let list = []
          list = res.data.data.sizeList
          this.skuMsgName = res.data.data.groupName
          this.skuMsg = JSON.parse(JSON.stringify({ ...row, specialPrint: specialPrint }))
          let pages = {}
          let cover = 0
          let single = 0
          list.forEach(page => {
            // pages[page.pageTypeCode] = page.spuPageName.isBase ? row.coverPage : 0
            if (page.pageTypeCode === 'COVER') {
              pages[page.pageTypeCode] = page.spuPageName.isBase ? row.coverPage : 0
              if (!page.spuPageName.isBase) {
                pages[page.pageTypeCode] = false
              }
            } else if (page.pageTypeCode === 'SINGLE') {
              pages[page.pageTypeCode] = page.spuPageName.isBase ? row.singlePage : 0
              if (!page.spuPageName.isBase) {
                pages[page.pageTypeCode] = false
              }
            }
          })
          list.forEach(page => {
            // // 页面名称表
            // if (page.typeName === '封面' && page.spuPageName.pageTypeId === 1) {
            page.isBase = page.spuPageName.isBase
            page.isEditable = page.spuPageName.isEditable

            if (page.pageTypeCode === 'TEXT') {
              let num = row.basePage
              for (let key in pages) {
                if (pages[key]) {
                  num -= pages[key]
                }
              }
              console.log(pages, num)
              page.pageNum = num
            } else if (page.pageTypeCode === 'COVER') { // 新加的封面可回显多页
              page.pageNum = row.coverPage
            } else {
              // COVER SINGLE 默认1 设置了读设置
              page.pageNum = !pages[page.pageTypeCode] ? 1 : pages[page.pageTypeCode]
            }
            // page.pageNum = page.pageTypeCode === 'TEXT' ? row.basePage - cover - single : pages[page.pageTypeCode]
            // page.pageNum = page.pageTypeCode === 'COVER' ? cover : page.pageTypeCode === 'SINGLE' ? single : page.pageTypeCode === 'TEXT' ? row.basePage - cover - single : -1
            // } else {
            //     page.isBase = page.spuPageName.isBase
            //     page.isEditable = page.spuPageName.isEditable
            //     page.pageNum = 1
            // }
          })
          this.skuMsg.skuPageSettingVOList = []
          list.forEach((item, index) => {
            let obj = {
              barCodePositionList: [],
              noAllowEditPage: this.skuMsg.skuPageSettingList[index].noAllowEditPage,
              deletePage: this.skuMsg.skuPageSettingList[index].deletePage,
              noAllowSortPage: this.skuMsg.skuPageSettingList[index].noAllowSortPage,
              generalFilePage: this.skuMsg.skuPageSettingList[index].generalFilePage,
              titlePagePdfPage: this.skuMsg.skuPageSettingList[index].titlePagePdfPage,
              pdfPage: this.skuMsg.skuPageSettingList[index].pdfPage,
              readonlyPage: this.skuMsg.skuPageSettingList[index].readonlyPage, // 只读页序
              skuPageSettingHalfPageVOS: this.skuMsg.skuPageSettingList[index].skuPageSettingHalfPageList?.length > 0 ? this.skuMsg.skuPageSettingList[index].skuPageSettingHalfPageList : [
                {
                  sort: null,
                  noAllowEditPage: '',
                  position: null
                }
              ],
              noComposePageNumEnd: this.skuMsg.skuPageSettingList[index].noComposePageNumEnd,
              noComposePageNumStart: this.skuMsg.skuPageSettingList[index].noComposePageNumStart,
              skuPageType: this.skuMsg.skuPageSettingList[index].skuPageType,
              splitPdf: this.skuMsg.skuPageSettingList[index].splitPdf,
              splitPageYk: this.skuMsg.skuPageSettingList[index].splitPageYk,
              splitPageYkDesc: this.skuMsg.skuPageSettingList[index].splitPageYkDesc,
              splitPageTp: this.skuMsg.skuPageSettingList[index].splitPageTp,
              splitPageTpDesc: this.skuMsg.skuPageSettingList[index].splitPageTpDesc,
              splitPageMstp: this.skuMsg.skuPageSettingList[index].splitPageMstp,
              splitPageMstpDesc: this.skuMsg.skuPageSettingList[index].splitPageMstpDesc,
              splitPageTjuv: this.skuMsg.skuPageSettingList[index].splitPageTjuv,
              splitPageTjuvDesc: this.skuMsg.skuPageSettingList[index].splitPageTjuvDesc,
              splitPageTljuv: this.skuMsg.skuPageSettingList[index].splitPageTljuv,
              splitPageTljuvDesc: this.skuMsg.skuPageSettingList[index].splitPageTljuvDesc,
              splitPageTlsyuv: this.skuMsg.skuPageSettingList[index].splitPageTlsyuv,
              splitPageTlsyuvDesc: this.skuMsg.skuPageSettingList[index].splitPageTlsyuvDesc,
              splitPageTlsjuv: this.skuMsg.skuPageSettingList[index].splitPageTlsjuv,
              splitPageTlsjuvDesc: this.skuMsg.skuPageSettingList[index].splitPageTlsjuvDesc,
              splitPageMGIYuv: this.skuMsg.skuPageSettingList[index].splitPageMGIYuv,
              splitPageMGIYuvDesc: this.skuMsg.skuPageSettingList[index].splitPageMGIYuvDesc,
              splitPageNpz: this.skuMsg.skuPageSettingList[index].splitPageNpz,
              splitPageNpzDesc: this.skuMsg.skuPageSettingList[index].splitPageNpzDesc,
              splitPageQt: this.skuMsg.skuPageSettingList[index].splitPageQt,
              splitPageQtDesc: this.skuMsg.skuPageSettingList[index].splitPageQtDesc,
              flip: this.skuMsg.skuPageSettingList[index].flip ? Number(this.skuMsg.skuPageSettingList[index].flip) : 0,
              flipAllPage: this.skuMsg.skuPageSettingList[index].flipAllPage,
              flipEvenPage: this.skuMsg.skuPageSettingList[index].flipEvenPage,
              flipOddPage: this.skuMsg.skuPageSettingList[index].flipOddPage,
              flipSpecifyPage: this.skuMsg.skuPageSettingList[index].flipSpecifyPage
            }
            console.log('item.barCodeList', item.barCodeList, this.skuMsg.skuPageSettingList[index].skuPageCodeSettingList)
            if (item.barCodeList.length > 0) {
              item.barCodeList.forEach(bar => {
                if (this.skuMsg.skuPageSettingList[index].skuPageCodeSettingList.length > 0) {
                  this.skuMsg.skuPageSettingList[index].skuPageCodeSettingList.forEach(set => {
                    console.log('set', set)
                    if (set.spuBarCode) {
                      if (set.spuBarCode.id === bar.id) {
                        obj.barCodePositionList.push({
                          barCodeId: bar.id,
                          barCodePosition: set.barCodePosition
                        })
                        // this.barPosition.page.has.forEach(pos => {
                        //   if (+pos.id === +set.barCodePosition) {
                        //   }
                        // })
                      }
                    } else {
                      obj.barCodePositionList.push({
                        barCodeId: bar.id,
                        barCodePosition: set.barCodePosition
                      })
                    }
                  })
                } else {
                  obj.barCodePositionList.push({
                    barCodeId: bar.id,
                    barCodePosition: ''
                  })
                }
              })
              console.log('obj.barCodePositionList+1111', obj.barCodePositionList)

              // 先注释掉：与祝福墙产品有有冲突，再遇到再看。<-----解决删除一条码了又新增之后，前后数据对不上少一条数据的问题
              let objList = {}
              obj.barCodePositionList.forEach(a => {
                objList[a.barCodeId] = a
              })
              // console.log('new item.barCodeList', item.barCodeList)
              // console.log('new objList', objList)
              obj.barCodePositionList = item.barCodeList.map(e => {
                if (objList[e.id]) {
                  return objList[e.id]
                } else {
                  return {
                    barCodeId: e.id,
                    barCodePosition: ''
                  }
                }
              })
              console.log('obj.barCodePositionList+2222', obj.barCodePositionList)
              // ------>
            }
            //  else {
            //   obj.barCodePositionList.push({
            //     barCodeId: '',
            //     barCodePosition: ''
            //   })
            // }
            this.skuMsg.skuPageSettingVOList.push(obj)
            if (item.spuPageName.pageTypeCode === 'COVER') {
              if (this.basicInfo.whitePageId) {
                item.barPosition = this.barPosition.cover.has
              } else {
                item.barPosition = this.barPosition.cover.none
              }
            } else {
              if (this.basicInfo.whitePageId) {
                item.barPosition = this.barPosition.page.has
              } else {
                item.barPosition = this.barPosition.page.none
              }
            }
          })
          this.pageNameTableData = JSON.parse(JSON.stringify(list))
          console.log('this.pageNameTableData', this.pageNameTableData)
          this.skuMsg = JSON.parse(JSON.stringify(this.skuMsg))
          console.log('获取this.skuMsg', this.skuMsg)
          this.countP()
          this.sizeDialog = false
          this.addSkuDialog = true
          this.$forceUpdate()
        }
      })
    },
    // 查看尺寸组
    checkSizeGroup (row) {
      composeGroupDetail(row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          this.checkSizeGroupTableData = [res.data.data]
        }
      })
      this.haddleSizeGroupDialog = true
    },
    // 审核
    check (type) {
      let status = ''
      status = type === '审核通过' ? 'AUDIT_SUCCESS' : type === '审核拒绝' ? 'AUDIT_FAIL' : ''
      skuGroupAudit({ skuGroupId: this.$route.query.id, status }).then(res => {
        if (res.data.success) {
          if (type === '审核通过') {
            this.$message.success('已通过')
          } else if (type === '审核拒绝') {
            this.$message.error('已拒绝')
          }
          this.$router.go(-1)
        }
      })
    },
    // 获取sku组信息
    async getSkuGroupMsg () {
      await skuGroupDetail(this.$route.query.id).then(res => {
        if (res.data.success) {
          let list = res.data.data
          console.log(list, 'list')
          this.isDiy = list.isDiy
          this.singlePrice = list.singlePrice
          this.skuMsg.isHavePromoCode = list.isHavePromoCode
          // this.startupsSpu = list.startupsSpu // 初创产品
          list.skuList = list.skuList.filter(sku => {
            return !sku.isSample
          })

          // 判断有没有sku，有=>尺寸组确定
          if (list.skuList.length !== 0) {
            console.log('list.skuList[0].composeSizeGroupId', list.skuList[0].composeSizeGroupId)
            if (this.$route.query.spuProperty !== 'NORMAL') {
              composeGroupDetail(list.skuList[0].composeSizeGroupId).then(res2 => {
                let obj = res2.data.data
                obj.detail = res2.data.data
                this.defaultSizeGroup = obj
                console.log('defaultSizeGroup', this.defaultSizeGroup)
              })
            }
          }

          // 处理属性
          list.dicts = []
          let dict = list.dictSet.split(';')
          dict.pop()
          dict.forEach(item => {
            item = item.split(':')
            list.dicts.push(item)
          })
          if (!list.isTimeLimit) {
            list.timeLimitStartTime = ''
            list.timeLimitEndTime = ''
          }
          if (list.timeLimitStartTime && list.timeLimitEndTime) {
            this.limitTime = [list.timeLimitStartTime, list.timeLimitEndTime]
          } else {
            this.limitTime = []
          }
          this.basicInfo = list
          this.selectSkuList = list.skuList
          console.log('this.basicInfo', this.basicInfo)
          if (this.$route.query.auditStatus === 'AUDIT_SUCCESS' && this.$route.query.onSale === 'false') {
            spuHasWhitePage(res.data.data.spuId).then(res => {
              if (res.data.success) {
                this.hasWhitePage = res.data.data + ''
              }
            })
          }
        }

        if (this.$route.query.spuProperty === 'NORMAL') {
          let dictList = []
          let ids = res.data.data.dictIdSet.split(';')
          ids.pop()
          ids.forEach(item => {
            dictList.push({
              id: item.split(':')[0],
              valId: +item.split(':')[1]
            })
          })
          let labels = res.data.data.dictSet.split(';')
          labels.pop()
          labels.forEach((item, index) => {
            dictList[index].key = item.split(':')[0]
          })
          let i = 0
          dictList.forEach((item, index) => {
            dictQueryByPid(item.id).then(res => {
              if (res.data.success) {
                item.vals = res.data.data
                res.data.data.forEach(val => {
                  if (+val.id === +item.valId) {
                    dictList[index].value = JSON.parse(JSON.stringify(val))
                  }
                })
              }
              i++
              if (i === dictList.length) {
                this.dictList = JSON.parse(JSON.stringify(dictList))
                this.$forceUpdate()
              }
            })
          })
        }
      })
      if (this.$hasPermission('pms:admin:special:store:list')) {
        // 获取特殊价格加盟店列表
        skuSpecialStoreList(this.$route.query.id).then(res => {
          if (res.data.success) {
            this.specialStoreList = res.data.data.data
          }
        })
      }
    },
    // ------------------------------------------------------
    count () {
      this.basicInfo.skuList.forEach((item, index) => {
        this.priceTableList[index] = []
        for (let i = item.basePage; i <= item.maxPage; i += item.baseStep) {
          this.priceTableList[index].push({
            page: i,
            price: (i - item.basePage) / item.baseStep * item.baseStepPrice + item.basePagePrice
          })
        }
      })
      this.isShow = true
    },
    changePage (val) {
      this.tempQueryInfo = val
      this.getTemplateThemeList()
    },
    sizeGroupchangePage (val) {
      this.sizeGroupQueryInfo = val
      this.getSizeGroupList()
    },
    handleSelectionChange (val) {
      this.selectTemplateList = val
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

// /deep/ .el-dialog {
//   background-color: transparent;
//   box-shadow: 0 0 0 0;
// }

.dialog {
  // position: relative;
  display: flex;
  flex-direction: column;
  //  background-color: #aaa !important;

  .btn-close {
    position: absolute;
    width: 90%;
    margin: -20px auto 0;
    display: flex;
    justify-content: flex-end;

    img {
      width: 34px;
      height: 34px;
      cursor: pointer;
    }
  }

  .dialog-box {
    // width: 100%;
    display: flex;
    align-items: center;
  }

  .switch-btn {
    // margin-top: 50%;
    width: 40px;
    height: 40px;
  }

  .switch-box {
    width: 80%;
    margin: 0 auto;

    .switch {
      // width: 80%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        // width: 868px;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  .dialog-title {
    // background: #e4e4e5;
    height: 57px;
    // width: 102.7%;
    line-height: 57px;
    margin-top: -30px;
    padding-left: 2.66%;
    margin-left: -2.66%;
    margin-bottom: 20px;
    font-size: 16px;
  }

  .dialog-btn {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    .submit {
      width: 100px;
      height: 40px;
      cursor: pointer;
      margin-top: 30px;
      background-color: #000;
      border-radius: 50px;
      line-height: 40px;
      text-align: center;
      color: white;
      font-size: 16px;
    }
  }
}

.switch-box {
  width: 80%;
  margin: 0 auto;

  .switch {
    // width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      // width: 868px;
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.detail-scroll::-webkit-scrollbar {
  display: none;
}
</style>
